import React, { useState, useEffect, useRef, useCallback } from 'react';
import { auth, db, functions } from './firebase';
import { 
  doc, onSnapshot, updateDoc, increment, collection, 
  addDoc, query, orderBy, setDoc, deleteDoc, 
  serverTimestamp, getDocs, runTransaction 
} from 'firebase/firestore';
import { formatarTempo, proximoTique } from './relogioPartida';
import { httpsCallable } from 'firebase/functions';
import { enviarNotificacao } from "./notificacoesService";
import { AGORA_APP_ID } from './agora-config';
import { useSessaoAgora } from './useSessaoAgora';
import EstadoLigacaoEstadio from './EstadoLigacaoEstadio';
import { reproduzirVideoNoContentor } from './agoraSession';
import { useAlturaLinhaVideo } from './useAlturaLinhaVideo';
import { construirMapaJogadores, uidAgoraDoUtilizador, contentorLocalDoUtilizador, contentorDeRemoto, limparContentorDeRemoto } from './mapaJogadores';
import PopupAtualizacaoEstadio from './PopupAtualizacaoEstadio';
import { shouldShowStadiumUpdate, markStadiumUpdateShown } from './stadiumUpdate';
import { adicionarXP } from './tabelaNiveis';
import { calcularNivel, obterImagemAdepto, obterImagemJogador } from './tabelaNiveis';

// IMPORTAÇÃO DOS PRESENTES REAIS
// 1. IMPORTAÇÕES (Tudo em minúsculas como na tua pasta)
// ==========================================
// LISTA MESTRE DE PRESENTES PREMIUM (50 FUTEBOL)
// ==========================================

// Bloco Novos Presentes (Futebol)
// Bloco 1 (150 Moedas)
import imgGift90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import vidGift90Minutos from './assets/presentes/leves/gift_90_minutos.webm';

import imgGiftAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import vidGiftAnelCampeao from './assets/presentes/leves/gift_anel_de_campeao.webm';

import imgGiftApito from './assets/presentes/miniaturas/gift_apito.webp';
import vidGiftApito from './assets/presentes/leves/gift_apito.webm';

import imgGiftBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import vidGiftBaliza from './assets/presentes/leves/gift_baliza.webm';

import imgGiftBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';
import vidGiftBancadaVip from './assets/presentes/leves/gift_bancada_vip.webm';

import imgGiftBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import vidGiftBancoSuplentes from './assets/presentes/leves/gift_banco_de_suplentes.webm';

import imgGiftBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import vidGiftBandeiraClaque from './assets/presentes/leves/gift_bandeira_da_claque.webm';

import imgGiftBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import vidGiftBandeirolaCanto from './assets/presentes/leves/gift_bandeirola_de_canto.webm';

import imgGiftBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import vidGiftBolaOuro from './assets/presentes/leves/gift_bola_de_ouro.webm';

import imgGiftBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';
import vidGiftBolaChamas from './assets/presentes/leves/gift_bola_em_chamas.webm';

// Bloco Novos Presentes - Grupo 2 (Futebol)
import imgGiftBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import vidGiftBotaDiamante from './assets/presentes/leves/gift_bota_de_diamante.webm';

import imgGiftBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import vidGiftBrasao from './assets/presentes/leves/gift_brasao.webm';

import imgGiftCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import vidGiftCachecol from './assets/presentes/leves/gift_cachecol.webm';

import imgGiftCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import vidGiftCaneleiras from './assets/presentes/leves/gift_caneleiras.webm';

import imgGiftCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';
import vidGiftCanhaoCamisolas from './assets/presentes/leves/gift_canhao_de_camisolas.webm';

import imgGiftCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import vidGiftCanhaoConfetes from './assets/presentes/leves/gift_canhao_de_confetes.webm';

import imgGiftCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import vidGiftCapitao from './assets/presentes/leves/gift_capitao.webm';

import imgGiftCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import vidGiftCartaoAmarelo from './assets/presentes/leves/gift_cartao_amarelo.webm';

import imgGiftCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import vidGiftCartaoVermelho from './assets/presentes/leves/gift_cartao_vermelho.webm';

import imgGiftChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';
import vidGiftChapeuGuardaRedes from './assets/presentes/leves/gift_chapeu_de_guarda_redes.webm';

// Bloco Novos Presentes - Grupo 3 (Futebol)
import imgGiftChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import vidGiftChuteira from './assets/presentes/leves/gift_chuteira.webm';

import imgGiftChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import vidGiftChuteirasChamas from './assets/presentes/leves/gift_chuteiras_em_chamas.webm';

import imgGiftCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import vidGiftCronometro from './assets/presentes/leves/gift_cronometro.webm';

import imgGiftFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import vidGiftFiscalLinha from './assets/presentes/leves/gift_fiscal_de_linha.webm';

import imgGiftFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';
import vidGiftFitasClaque from './assets/presentes/leves/gift_fitas_da_claque.webm';

import imgGiftFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import vidGiftFumoClaque from './assets/presentes/leves/gift_fumo_da_claque.webm';

import imgGiftGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import vidGiftGorroAdepto from './assets/presentes/leves/gift_gorro_do_adepto.webm';

import imgGiftHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import vidGiftHallEntrada from './assets/presentes/leves/gift_hall_de_entrada.webm';

import imgGiftHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import vidGiftHatTrick from './assets/presentes/leves/gift_hat_trick.webm';

import imgGiftHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';
import vidGiftHolofotes from './assets/presentes/leves/gift_holofotes.webm';

// Bloco Novos Presentes - Grupo 4 (Futebol)
import imgGiftLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import vidGiftLuvaEspuma from './assets/presentes/leves/gift_luva_de_espuma.webm';

import imgGiftLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import vidGiftLuvaPlatina from './assets/presentes/leves/gift_luva_de_platina.webm';

import imgGiftLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import vidGiftLuvasGuardaRedes from './assets/presentes/leves/gift_luvas_de_guarda_redes.webm';

import imgGiftMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import vidGiftMedalhaCampeao from './assets/presentes/leves/gift_medalha_de_campeao.webm';

import imgGiftMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';
import vidGiftMedalhaViceCampeao from './assets/presentes/leves/gift_medalha_de_vice_campeao.webm';

import imgGiftMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import vidGiftMegafone from './assets/presentes/leves/gift_megafone.webm';

import imgGiftMeias from './assets/presentes/miniaturas/gift_meias.webp';
import vidGiftMeias from './assets/presentes/leves/gift_meias.webm';

import imgGiftMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import vidGiftMelhorTreinador from './assets/presentes/leves/gift_melhor_treinador.webm';

import imgGiftMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import vidGiftMoedaAoAr from './assets/presentes/leves/gift_moeda_ao_ar.webm';

import imgGiftPlacard from './assets/presentes/miniaturas/gift_placard.webp';
import vidGiftPlacard from './assets/presentes/leves/gift_placard.webm';

// Bloco Novos Presentes - Grupo 5 (Futebol - Final)
import imgGiftRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import vidGiftRelvado from './assets/presentes/leves/gift_relvado.webm';

import imgGiftSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import vidGiftSprayBarreira from './assets/presentes/leves/gift_spray_de_barreira.webm';

import imgGiftSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import vidGiftSubstituicao from './assets/presentes/leves/gift_substituicao.webm';

import imgGiftTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import vidGiftTacaSuprema from './assets/presentes/leves/gift_taca_suprema.webm';

import imgGiftTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';
import vidGiftTamborClaque from './assets/presentes/leves/gift_tambor_da_claque.webm';

import imgGiftTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import vidGiftTorresEstadio from './assets/presentes/leves/gift_torres_do_estadio.webm';

import imgGiftTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import vidGiftTrofeuCampeao from './assets/presentes/leves/gift_trofeu_de_campeao.webm';

import imgGiftTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import vidGiftTrofeuGuardaRedes from './assets/presentes/leves/gift_trofeu_de_guarda_redes.webm';

import imgGiftVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import vidGiftVitoria from './assets/presentes/leves/gift_vitoria.webm';

import imgGiftVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';
import vidGiftVuvuzela from './assets/presentes/leves/gift_vuvuzela.webm';
import PresenteTransparente from './PresenteTransparente';
import { videoSemFundo } from './presentesSemFundo';
import { useAquecerPresentes } from './useAquecerPresentes';
import { useFilaDePresentes } from './filaDePresentes';

const LISTA_PRESENTES = [
  // ==========================================
  // BLOCO 1: 150 MOEDAS
  // ==========================================
  { id: 1, nome: '90 Minutos', preco: 150, icone: imgGift90Minutos, video: vidGift90Minutos },
  { id: 2, nome: 'Anel de Campeão', preco: 150, icone: imgGiftAnelCampeao, video: vidGiftAnelCampeao },
  { id: 3, nome: 'Apito', preco: 150, icone: imgGiftApito, video: vidGiftApito },
  { id: 4, nome: 'Baliza', preco: 150, icone: imgGiftBaliza, video: vidGiftBaliza },
  { id: 5, nome: 'Bancada VIP', preco: 150, icone: imgGiftBancadaVip, video: vidGiftBancadaVip },

  // ==========================================
  // BLOCO 2: 300 MOEDAS
  // ==========================================
  { id: 6, nome: 'Banco de Suplentes', preco: 300, icone: imgGiftBancoSuplentes, video: vidGiftBancoSuplentes },
  { id: 7, nome: 'Bandeira da Claque', preco: 300, icone: imgGiftBandeiraClaque, video: vidGiftBandeiraClaque },
  { id: 8, nome: 'Bandeirola de Canto', preco: 300, icone: imgGiftBandeirolaCanto, video: vidGiftBandeirolaCanto },
  { id: 9, nome: 'Bola de Ouro', preco: 300, icone: imgGiftBolaOuro, video: vidGiftBolaOuro },
  { id: 10, nome: 'Bola em Chamas', preco: 300, icone: imgGiftBolaChamas, video: vidGiftBolaChamas },

  // ==========================================
  // BLOCO 3: 450 MOEDAS
  // ==========================================
  { id: 11, nome: 'Bota de Diamante', preco: 450, icone: imgGiftBotaDiamante, video: vidGiftBotaDiamante },
  { id: 12, nome: 'Brasão', preco: 450, icone: imgGiftBrasao, video: vidGiftBrasao },
  { id: 13, nome: 'Cachecol', preco: 450, icone: imgGiftCachecol, video: vidGiftCachecol },
  { id: 14, nome: 'Caneleiras', preco: 450, icone: imgGiftCaneleiras, video: vidGiftCaneleiras },
  { id: 15, nome: 'Canhão de Camisolas', preco: 450, icone: imgGiftCanhaoCamisolas, video: vidGiftCanhaoCamisolas },

  // ==========================================
  // BLOCO 4: 600 MOEDAS
  // ==========================================
  { id: 16, nome: 'Canhão de Confetes', preco: 600, icone: imgGiftCanhaoConfetes, video: vidGiftCanhaoConfetes },
  { id: 17, nome: 'Capitão', preco: 600, icone: imgGiftCapitao, video: vidGiftCapitao },
  { id: 18, nome: 'Cartão Amarelo', preco: 600, icone: imgGiftCartaoAmarelo, video: vidGiftCartaoAmarelo },
  { id: 19, nome: 'Cartão Vermelho', preco: 600, icone: imgGiftCartaoVermelho, video: vidGiftCartaoVermelho },
  { id: 20, nome: 'Chapéu de Guarda-Redes', preco: 600, icone: imgGiftChapeuGuardaRedes, video: vidGiftChapeuGuardaRedes },

  // ==========================================
  // BLOCO 5: 750 MOEDAS
  // ==========================================
  { id: 21, nome: 'Chuteira', preco: 750, icone: imgGiftChuteira, video: vidGiftChuteira },
  { id: 22, nome: 'Chuteiras em Chamas', preco: 750, icone: imgGiftChuteirasChamas, video: vidGiftChuteirasChamas },
  { id: 23, nome: 'Cronómetro', preco: 750, icone: imgGiftCronometro, video: vidGiftCronometro },
  { id: 24, nome: 'Fiscal de Linha', preco: 750, icone: imgGiftFiscalLinha, video: vidGiftFiscalLinha },
  { id: 25, nome: 'Fitas da Claque', preco: 750, icone: imgGiftFitasClaque, video: vidGiftFitasClaque },

  // ==========================================
  // BLOCO 6: 900 MOEDAS
  // ==========================================
  { id: 26, nome: 'Fumo da Claque', preco: 900, icone: imgGiftFumoClaque, video: vidGiftFumoClaque },
  { id: 27, nome: 'Gorro do Adepto', preco: 900, icone: imgGiftGorroAdepto, video: vidGiftGorroAdepto },
  { id: 28, nome: 'Hall de Entrada', preco: 900, icone: imgGiftHallEntrada, video: vidGiftHallEntrada },
  { id: 29, nome: 'Hat-Trick', preco: 900, icone: imgGiftHatTrick, video: vidGiftHatTrick },
  { id: 30, nome: 'Holofotes', preco: 900, icone: imgGiftHolofotes, video: vidGiftHolofotes },

  // ==========================================
  // BLOCO 7: 1050 MOEDAS
  // ==========================================
  { id: 31, nome: 'Luva de Espuma', preco: 1050, icone: imgGiftLuvaEspuma, video: vidGiftLuvaEspuma },
  { id: 32, nome: 'Luva de Platina', preco: 1050, icone: imgGiftLuvaPlatina, video: vidGiftLuvaPlatina },
  { id: 33, nome: 'Luvas de Guarda-Redes', preco: 1050, icone: imgGiftLuvasGuardaRedes, video: vidGiftLuvasGuardaRedes },
  { id: 34, nome: 'Medalha de Campeão', preco: 1050, icone: imgGiftMedalhaCampeao, video: vidGiftMedalhaCampeao },
  { id: 35, nome: 'Medalha de Vice-Campeão', preco: 1050, icone: imgGiftMedalhaViceCampeao, video: vidGiftMedalhaViceCampeao },

  // ==========================================
  // BLOCO 8: 1200 MOEDAS
  // ==========================================
  { id: 36, nome: 'Megafone', preco: 1200, icone: imgGiftMegafone, video: vidGiftMegafone },
  { id: 37, nome: 'Meias', preco: 1200, icone: imgGiftMeias, video: vidGiftMeias },
  { id: 38, nome: 'Melhor Treinador', preco: 1200, icone: imgGiftMelhorTreinador, video: vidGiftMelhorTreinador },
  { id: 39, nome: 'Moeda ao Ar', preco: 1200, icone: imgGiftMoedaAoAr, video: vidGiftMoedaAoAr },
  { id: 40, nome: 'Placard', preco: 1200, icone: imgGiftPlacard, video: vidGiftPlacard },

  // ==========================================
  // BLOCO 9: 1350 MOEDAS
  // ==========================================
  { id: 41, nome: 'Relvado', preco: 1350, icone: imgGiftRelvado, video: vidGiftRelvado },
  { id: 42, nome: 'Spray de Barreira', preco: 1350, icone: imgGiftSprayBarreira, video: vidGiftSprayBarreira },
  { id: 43, nome: 'Substituição', preco: 1350, icone: imgGiftSubstituicao, video: vidGiftSubstituicao },
  { id: 44, nome: 'Taça Suprema', preco: 1350, icone: imgGiftTacaSuprema, video: vidGiftTacaSuprema },
  { id: 45, nome: 'Tambor da Claque', preco: 1350, icone: imgGiftTamborClaque, video: vidGiftTamborClaque },

  // ==========================================
  // BLOCO 10: 1500 MOEDAS
  // ==========================================
  { id: 46, nome: 'Torres do Estádio', preco: 1500, icone: imgGiftTorresEstadio, video: vidGiftTorresEstadio },
  { id: 47, nome: 'Troféu de Campeão', preco: 1500, icone: imgGiftTrofeuCampeao, video: vidGiftTrofeuCampeao },
  { id: 48, nome: 'Troféu de Guarda-Redes', preco: 1500, icone: imgGiftTrofeuGuardaRedes, video: vidGiftTrofeuGuardaRedes },
  { id: 49, nome: 'Vitória', preco: 1500, icone: imgGiftVitoria, video: vidGiftVitoria },
  { id: 50, nome: 'Vuvuzela', preco: 1500, icone: imgGiftVuvuzela, video: vidGiftVuvuzela }
];

  function TorneiosPK({ idBatalha, idJogoNaArvore, espectador, aoSair, determinarClaqueChampions }) {
    // Põe os vídeos dos presentes a descarregar já, para o primeiro presente não chegar atrasado.
    useAquecerPresentes();

  // TRANCA DE REDIRECIONAMENTO CHAMPIONS: Desvia de forma invisível as rotas antigas para a coleção isolada!
  const db_colecao = "champions_partidas";

  const [batalha, setBatalha] = useState(null);
  const [microLigado, setMicroLigado] = useState(true);
  
  // 🚨 REPLICAÇÃO ARENA PK: Função global do microfone 100% individual
  const alternarMicrofoneBatalha = () => setMicroLigado((ligado) => !ligado);

  const [mensagemJuiz, setMensagemJuiz] = useState("");
  
  // 👁️ CORREÇÃO DO OLHINHO: Alinhado a 100% com as variáveis que a tua cortina da Champions lê!
  const [mostrarEspectadoresPK, setMostrarEspectadoresPK] = useState(false);
  const [listaEspectadoresPK, setListaEspectadoresPK] = useState([]);
  const [mostrarListaEspectadores, setMostrarListaEspectadores] = useState(false); // Tranca extra de compatibilidade
  const [listaEspectadores, setListaEspectadores] = useState([]); // Tranca extra de compatibilidade
  
  const [streamerSelecionadoPresente, setStreamerSelecionadoPresente] = useState('A'); // 'A' = Esquerda, 'B' = Direita

  // A linha de vídeo ocupa todo o espaço que sobra (ver useAlturaLinhaVideo.js).
   // 🚨 SISTEMA DE ESTEIRA SUPREMA (QUEUE): Acaba com os travamentos e desaparecimento de presentes!
  // FILA DE PRESENTES: um de cada vez, os outros esperam; ao acabar entra o
  // seguinte. A bomba toca quando o presente ENTRA no ecrã. (src/filaDePresentes.js)
  const filaPresentes = useFilaDePresentes({
    aoComecar: () => {
      try {
        const somBomba = new Audio("/sounds/bomba-explosao.mp3");
        somBomba.volume = 1.0;
        somBomba.play().catch(e => console.log("Autoplay retido pelo browser:", e));
      } catch (errSom) {
        console.error("Erro ao reproduzir áudio no presente:", errSom);
      }
    },
  });
  const videoAtivo = filaPresentes.atual?.url || null;
  const chaveVideoAtivo = filaPresentes.atual?.chave || '';
  
  const [textoMensagem, setTextoMensagem] = useState("");
  const [mensagensChat, setMensagensChat] = useState([]);

  const [mostrarResultadoFinal, setMostrarResultadoFinal] = useState(false);
  const [mostrarOpcoesFim, setMostrarOpcoesFim] = useState(false);
  const [totalTapTapsArena, setTotalTapTapsArena] = useState(0);
  const [tapsClaqueA, setTapsClaqueA] = useState(0);
  const [tapsClaqueB, setTapsClaqueB] = useState(0);
  
  // 🎁 CORREÇÃO DOS PRESENTES: Alinhado com o motor dinâmico do ecrã do espetador!
  const [mostrarPresentesPK, setMostrarPresentesPK] = useState(false);

  // 🛡️ EXTRAÇÃO EXTRA: Cria atalhos seguros para os IDs dos streamers para proteger os cliques das Claques
  const idA = batalha?.idA || null;
  const idB = batalha?.idB || null;

    // 🚨 REPLICAÇÃO ARENA PK: Estados de sócios e contadores das claques da Champions
  const [euPertencoAClaqueA, setEuPertencoAClaqueA] = useState(false);
  const [euPertencoAClaqueB, setEuPertencoAClaqueB] = useState(false);
  const [totalMembrosClaqueA, setTotalMembrosClaqueA] = useState(0);
  const [totalMembrosClaqueB, setTotalMembrosClaqueB] = useState(0);
  const [idsClaqueA, setIdsClaqueA] = useState([]);
  const [idsClaqueB, setIdsClaqueB] = useState([]);

  // SENSOR MESTRE DA CLAQUE: Escuta os sócios e valida a tua pertença vitalícia na Champions
  useEffect(() => {
    if (!batalha?.idA || !auth.currentUser?.uid) return;
    const meuUidLogado = auth.currentUser.uid;
    let unsubMembrosA = null;
    let unsubMembrosB = null;

    const iniciarSensoresMembrosChampions = async () => {
      try {
        const { doc: fDoc, getDoc: fGetDoc, collection: fColl, onSnapshot: fOnSnapshot, query: fQuery, where: fWhere } = await import('firebase/firestore');
        
        // 1. Verifica se EU sou sócio do Streamer A na Champions
      const docClaqueARef = fDoc(db, "utilizadores", batalha?.idA, "claque_champions_membros", meuUidLogado);
        const snapA = await fGetDoc(docClaqueARef);
        setEuPertencoAClaqueA(snapA.exists() && snapA.data()?.ativo === true);

        // 2. Verifica se EU sou sócio do Streamer B na Champions
        if (batalha?.idB) {
        const docClaqueBRef = fDoc(db, "utilizadores", batalha?.idB, "claque_champions_membros", meuUidLogado);
          const snapB = await fGetDoc(docClaqueBRef);
          setEuPertencoAClaqueB(snapB.exists() && snapB.data()?.ativo === true);
        }

        // 3. Escuta em tempo real os sócios ativos do Streamer A
      const claqueACollRef = fColl(db, "utilizadores", batalha?.idA, "claque_champions_membros");
        const qClaqueA = fQuery(claqueACollRef, fWhere("ativo", "==", true));
        unsubMembrosA = fOnSnapshot(qClaqueA, (snapCollA) => {
          setTotalMembrosClaqueA(snapCollA.size);
          setIdsClaqueA(snapCollA.docs.map(d => d.id));
        });

        // 4. Escuta em tempo real os sócios ativos do Streamer B
        if (batalha?.idB) {
        const claqueBCollRef = fColl(db, "utilizadores", batalha?.idB, "claque_champions_membros");
          const qClaqueB = fQuery(claqueBCollRef, fWhere("ativo", "==", true));
          unsubMembrosB = fOnSnapshot(qClaqueB, (snapCollB) => {
            setTotalMembrosClaqueB(snapCollB.size);
            setIdsClaqueB(snapCollB.docs.map(d => d.id));
          });
        }
      } catch (errCheck) {
        console.error("Erro nos sensores de membros da claque:", errCheck);
      }
    };

    iniciarSensoresMembrosChampions();
    return () => {
      if (unsubMembrosA) unsubMembrosA();
      if (unsubMembrosB) unsubMembrosB();
    };
  }, [batalha?.idA, batalha?.idB]);

      // FUNÇÃO REAL: Comprar Bilhete Claque Esquerda (50% Streamer / 50% Admin)
  const comprarAbonoClaqueChampionsA = async () => {
    if (!batalha?.idA || !auth.currentUser?.uid) return;
    const meuUidLogado = auth.currentUser.uid;
    try {
      const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, setDoc: fSetDoc, serverTimestamp: fTimestamp, increment: fIncrement } = await import('firebase/firestore');
      const meuUserRef = fDoc(db, "utilizadores", meuUidLogado);
      const meuSnap = await fGetDoc(meuUserRef);
      const saldoBolasReal = meuSnap.data()?.saldoBolas || meuSnap.data()?.saldo || 0;

      if (saldoBolasReal < 200) {
        alert("Saldo insuficiente para entrar na Claque Oficial Champions! ⚽");
        return;
      }

      // 1. Deduz as 200 Bolas do saldo do visitante
      const campoSaldo = meuSnap.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(meuUserRef, { [campoSaldo]: fIncrement(-200) });

      // 2. Transfere 50% (100 Bolas) para o Streamer A
      const streamerARef = fDoc(db, "utilizadores", batalha.idA);
      const snapStrA = await fGetDoc(streamerARef);
      const campoSaldoStrA = snapStrA.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(streamerARef, { [campoSaldoStrA]: fIncrement(100) });

      // 3. Regista 50% (100 Bolas) para a Administração
      const meuIdAdminTorneioClaque = "wkvSZZR5zdUvweoBuydAept6eOn1";
      await fUpdateDoc(fDoc(db, "utilizadores", meuIdAdminTorneioClaque), { comissaoAppBolas: fIncrement(100) }).catch(() => {});

      // 4. Grava o sócio vitalício na subcoleção da Champions do Streamer
      const docClaqueARef = fDoc(db, "utilizadores", batalha.idA, "claque_champions_membros", meuUidLogado);
      await fSetDoc(docClaqueARef, { uid: meuUidLogado, nome: auth.currentUser?.displayName || "Adepto", foto: auth.currentUser?.photoURL || "", ativo: true, criadoEm: fTimestamp() });

      // 5. Updates ao vivo na sala do jogo
      if (idBatalha) {
        await fUpdateDoc(fDoc(db, "champions_partidas", idBatalha), { claqueAtivosA: fIncrement(1) }).catch(() => {});
      }

            // XP AUTOMÁTICO: ABONO CLAQUE A
        if (meuUidLogado) {
          adicionarXP(meuUidLogado, 'adepto', 200);
        }
        if (batalha?.idA && batalha.idA !== meuUidLogado) {
          adicionarXP(batalha.idA, 'jogador', 200);
        }

      setEuPertencoAClaqueA(true);
      alert(`Bem-vindo à Claque Oficial de ${batalha?.nomeA || 'Anfitrião'} na Champions! 📣`);
    } catch (err) { console.error(err); }
  };

    // FUNÇÃO REAL: Comprar Bilhete Claque Direita (50% Streamer / 50% Admin)
  const comprarAbonoClaqueChampionsB = async () => {
    if (!batalha?.idB || !auth.currentUser?.uid) return;
    const meuUidLogado = auth.currentUser.uid;
    try {
      const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, setDoc: fSetDoc, serverTimestamp: fTimestamp, increment: fIncrement } = await import('firebase/firestore');
      const meuUserRef = fDoc(db, "utilizadores", meuUidLogado);
      const meuSnap = await fGetDoc(meuUserRef);
      const saldoBolasReal = meuSnap.data()?.saldoBolas || meuSnap.data()?.saldo || 0;

      if (saldoBolasReal < 200) {
        alert("Saldo insuficiente para entrar na Claque Oficial Champions! ⚽");
        return;
      }

      // 1. Deduz as 200 Bolas do saldo do visitante
      const campoSaldo = meuSnap.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(meuUserRef, { [campoSaldo]: fIncrement(-200) });

      // 2. Transfere 50% (100 Bolas) para o Streamer B
      const streamerBRef = fDoc(db, "utilizadores", batalha.idB);
      const snapStrB = await fGetDoc(streamerBRef);
      const campoSaldoStrB = snapStrB.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(streamerBRef, { [campoSaldoStrB]: fIncrement(100) });

      // 3. Regista 50% (100 Bolas) para a Administração
      const meuIdAdminTorneioClaque = "wkvSZZR5zdUvweoBuydAept6eOn1";
      await fUpdateDoc(fDoc(db, "utilizadores", meuIdAdminTorneioClaque), { comissaoAppBolas: fIncrement(100) }).catch(() => {});

      // 4. Grava o sócio vitalício na subcoleção da Champions do Streamer B
      const docClaqueBRef = fDoc(db, "utilizadores", batalha.idB, "claque_champions_membros", meuUidLogado);
      await fSetDoc(docClaqueBRef, { uid: meuUidLogado, nome: auth.currentUser?.displayName || "Adepto", foto: auth.currentUser?.photoURL || "", ativo: true, criadoEm: fTimestamp() });

      // 5. Updates ao vivo na sala do jogo
      if (idBatalha) {
        await fUpdateDoc(fDoc(db, "champions_partidas", idBatalha), { claqueAtivosB: fIncrement(1) }).catch(() => {});
      }

            // XP AUTOMÁTICO: ABONO CLAQUE B
        if (meuUidLogado) {
          adicionarXP(meuUidLogado, 'adepto', 200);
        }
        if (batalha?.idB && batalha.idB !== meuUidLogado) {
          adicionarXP(batalha.idB, 'jogador', 200);
        }

      setEuPertencoAClaqueB(true);
      alert(`Bem-vindo à Claque Oficial de ${batalha?.nomeB || 'Rival'} na Champions! 📣`);
    } catch (err) { console.error(err); }
  };

    // PEÇA 1 - PASSO A: Sensores de monitorização do tique do cronómetro da Arena
  const ultimoTiqueRef = useRef({ tempo: null, em: Date.now() });
  const [relogioParado, setRelogioParado] = useState(false);

  useEffect(() => {
    if (!batalha) return;
    if (batalha.tempo !== ultimoTiqueRef.current.tempo) {
      ultimoTiqueRef.current = { tempo: batalha.tempo, em: Date.now() };
      setRelogioParado(false);
    }
  }, [batalha?.tempo, batalha]);

  useEffect(() => {
    const emJogo = batalha?.fase && batalha.fase !== "ESPERA" && batalha.fase !== "FIM";
    if (!emJogo) { setRelogioParado(false); return; }

    const vigia = setInterval(() => {
      setRelogioParado(Date.now() - ultimoTiqueRef.current.em > 10000);
    }, 2000);
    return () => clearInterval(vigia);
  }, [batalha?.fase]);

  const messagesEndRef = useRef(null);

  // SESSÃO AGORA partilhada (ver agoraSession.js): tranca anti-duplo arranque,
  // limite de 15s e teardown garantido ao desmontar.
  const ligacao = useSessaoAgora('TorneiosPK');

  // 🚨 REPLICAÇÃO ARENA PK: Aplica a intenção do microfone à pista local do Agora.io com total segurança (Limpado e Sem Duplicações!)
  useEffect(() => {
    const pistaAudio = ligacao?.sessao?.audio;
    if (!pistaAudio) return;

    Promise.resolve(pistaAudio.setMuted(!microLigado))
      .catch((err) => console.error("Erro ao alternar microfone na Champions:", err));
  }, [microLigado, ligacao?.estado, ligacao?.sessao]);

  // 🚨 TRANCA SUPREMA ANTI-CONGELAMENTO: Força a fase "FIM" se o relógio travar nos Pênaltis
  useEffect(() => {
    if (!batalha || !idBatalha) return;

    const tempoAtual = Number(batalha?.tempo || 0);
    const faseAtualTexto = String(batalha?.fase || "").toUpperCase();
    
    // Alvo expandido para cobrir "PENALTIS" ou "PENALTIES" de forma infalível
    if ((faseAtualTexto === "PENALTIS" || faseAtualTexto === "PENALTIES") && tempoAtual <= 1 && batalha?.fase !== "FIM") {
      
      console.log("Tranca acionada! Forçando fase FIM para libertar a Moeda ao Ar... 🪙");
      
      const partidaRef = doc(db, "champions_partidas", idBatalha);
      updateDoc(partidaRef, {
        fase: "FIM",
        tempo: 0
      }).catch((err) => console.log("Erro ao forçar fim dos pênaltis:", err));
    }
  }, [batalha?.tempo, batalha?.fase, idBatalha]);

  // REPOR O ESTADO DA PARTIDA.
  const reporEstadoDaPartida = useCallback((limparBatalha = false) => {
    if (limparBatalha) setBatalha(null);
    filaPresentes.limpar();
    setMensagemJuiz("");
    setMensagensChat([]);
    setTextoMensagem("");
    setMostrarResultadoFinal(false);
    setTotalTapTapsArena(0);
    setTapsClaqueA(0);
    setTapsClaqueB(0);
    setMostrarPresentesPK(false);
    setMostrarOpcoesFim(false);
  }, []);

  // Partida nova (id diferente): limpa tudo, incluindo o documento antigo.
  useEffect(() => {
    reporEstadoDaPartida(true);
  }, [idBatalha, reporEstadoDaPartida]);

  const scrollToBottom = () => {
    setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: 'auto', block: 'end' });
      }
    }, 200);
  };

      // AVISO DIÁRIO DE NOVIDADES DO ESTÁDIO (DESATIVADO NA CHAMPIONS PARA NÃO BLOQUEAR O JOGO)
  const [mostrarAvisoEstadio, setMostrarAvisoEstadio] = useState(false);

  useEffect(() => {
    setMostrarAvisoEstadio(false);
  }, []);

    const enviarPresente = async (presente, receptorID) => {
    // PRESERVADO: A batalha de presentes fica aberta no tempo regulamentar, prolongamentos e penaltis
    const fasesPermitidas = ["1ª PARTE", "2ª PARTE", "PROLONGAMENTO_1", "PROLONGAMENTO_2", "PENALTIS", "PENALTIES"];
    if (!batalha || !fasesPermitidas.includes(String(batalha?.fase || "").toUpperCase())) return;

    try {
      // 0. TRANCA BANCÁRIA: Valida se o utilizador tem saldo real (evita saldo negativo)
      const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, increment: fIncrement } = await import('firebase/firestore');
      const meuSnap = await fGetDoc(fDoc(db, "utilizadores", auth.currentUser.uid));
      const saldoVisitanteReal = meuSnap.data()?.saldoBolas !== undefined ? meuSnap.data()?.saldoBolas : (meuSnap.data()?.saldo || 0);
      
      if (saldoVisitanteReal < presente.preco) {
        alert("Saldo insuficiente! ⚽");
        return;
      }

      // 1. Tira o preço real do presente ao saldo do espetador (lê o campo premium correto)
      const campoSaldoVisitante = meuSnap.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), {
        [campoSaldoVisitante]: fIncrement(-presente.preco)
      });

            // 2. SEPARAÇÃO DE RECEITAS 100% EM BOLAS (CHAMPIONS STAGE: 50/25/25)
      const comissaoStreamerBolas = Math.round(presente.preco * 0.50);
      const comissaoPoteBolas = Math.round(presente.preco * 0.25); 
      const comissaoAppBolas = Math.round(presente.preco * 0.25); // O teu lucro de Administrador

      const campoPontos = receptorID === batalha.idA ? "pontosA" : "pontosB";
      const campoContadorPrs = receptorID === batalha.idA ? "totalPresentesRecebidosA" : "totalPresentesRecebidosB";

      // 3. ATUALIZAÇÃO SINCRO: Salva os pontos e as moedas no pote da partida ativa em Bolas
      await fUpdateDoc(fDoc(db, "champions_partidas", idBatalha), {
        [campoPontos]: fIncrement(presente.preco),
        ultimoVideo: presente.video,
        [campoContadorPrs]: fIncrement(1),
        poteBolasJogo: fIncrement(comissaoPoteBolas)
      });

          // 🚨 ALERTA PREMIUM NO CHAT: Injeta o log na rota certa (chatsArena) com o gatilho para a esteira!
      try {
        const { collection: fCollection, addDoc: fAddDoc, serverTimestamp: fServerTimestamp } = await import('firebase/firestore');
        const nomeAdeptoPresente = meuSnap.data()?.nomeCompleto || meuSnap.data()?.nome || auth.currentUser?.displayName || "Um adepto";
        const nomeDestinatarioPresente = receptorID === batalha?.idA ? (batalha?.nomeA || "Streamer A") : (batalha?.nomeB || "Streamer B");
        
             const fotoAdeptoPresente = meuSnap.data()?.fotoUrl || meuSnap.data()?.foto || auth.currentUser?.photoURL || "";

     await fAddDoc(fCollection(db, "champions_partidas", idBatalha, "chatsArena"), {
       texto: ` enviou [${presente.nome || "Presente"}] para ${nomeDestinatarioPresente}! ⚽💥`,
       nome: "🏆 SISTEMA CHAMPIONS",
       nomeInfrator: `🎁 ${nomeAdeptoPresente}`, // Guardamos o nome do adepto isolado aqui para o destacar
       uid: "sistema_champions",
       fotoUrl: fotoAdeptoPresente, // Injeta a foto real para acabar com a bola preta!
       foto: fotoAdeptoPresente, // Fallback duplo de segurança para a imagem
       criadoEm: fServerTimestamp(),
       tipo: "sistema",
       videoGatilho: presente.video 
     });
      } catch (errChatLog) {
        console.error("Erro ao injetar alerta de presente no chat:", errChatLog);
      }

      // A. O Streamer do jogo atual recebe os seus 50% em moedas/bolas
      const streamerRef = fDoc(db, "utilizadores", receptorID);
      const snapStr = await fGetDoc(streamerRef);
      const campoSaldoStreamer = snapStr.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(streamerRef, {
        [campoSaldoStreamer]: fIncrement(comissaoStreamerBolas)
      });

            // B. O Pote Global acumula na partida atual e injeta de forma unificada no Pote Central da Árvore Geral!
      await fUpdateDoc(fDoc(db, "champions_partidas", idBatalha), {
        poteBolasGlobal: fIncrement(comissaoPoteBolas)
      }).catch(() => {});

        // 🚨 INJEÇÃO MESTRE CHAMPIONS: Acumula o Pote da Final puramente em Bolas
    const idDaMinhaSalaChampions = batalha?.salaTorneioId || "estadio_global_ativo";
    await fUpdateDoc(fDoc(db, "champions_ativa", idDaMinhaSalaChampions), {
      poteBolasGlobalArvore: fIncrement(comissaoPoteBolas)
    }).catch(() => {});

          // ========================================================
      // ENVIAR XP AUTOMÁTICO - PRESENTES CHAMPIONS
      // ========================================================
      const meuUidChampions = auth?.currentUser?.uid;
      if (meuUidChampions) {
        adicionarXP(meuUidChampions, 'adepto', presente.preco);
      }
      if (receptorID && receptorID !== meuUidChampions) {
        adicionarXP(receptorID, 'jogador', presente.preco);
      }
      // ========================================================


    // C. A tua conta mestre de Administrador arrecada os 25% de lucro de comissão
    const meuIdAdminTorneio = "wkvSZZR5zdUvweoBuydAept6eOn1";
    await fUpdateDoc(fDoc(db, "utilizadores", meuIdAdminTorneio), {
      comissaoAppBolas: fIncrement(comissaoAppBolas)
    }).catch(errT => console.error("Erro na comissão do Torneio:", errT));

    } catch (err) { console.error("Erro ao enviar presente:", err); }
  };

  // ANTENA DE DADOS EM TEMPO REAL: Escuta a partida isolada da Champions de forma unificada!
  useEffect(() => {
    if (!idBatalha || idBatalha === "undefined") return;

    const unsubPartida = onSnapshot(doc(db, "champions_partidas", idBatalha), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setBatalha(data);
        
        // Sincroniza os contadores das Claques e do Pote dinâmico na tela do jogo
        setTotalTapTapsArena(data.totalTapTaps || 0);
        setTapsClaqueA(Number(data.tapsClaqueA || data.claqueAtivosA || 0));
        setTapsClaqueB(Number(data.tapsClaqueB || data.claqueAtivosB || 0));
                if (data.poteBolasJogo !== undefined) {
            setPoteBolas(Number(data.poteBolasJogo));
          }
      }
    });
    return () => unsubPartida();
  }, [idBatalha]);

  // ENTRADA NO CANAL DE VÍDEO DA ELIMINATÓRIA.
  useEffect(() => {
    if (!idBatalha || idBatalha === "undefined" || auth.currentUser?.uid == null) return;
    if (!batalha?.idA) return;

    const entrarNoCampo = async () => {
      let tokenReal = null;
      try {
        const chamarGerador = httpsCallable(functions, 'gerarTokenAgora');
        const resultadoServidor = await chamarGerador({ idBatalha });
        tokenReal = resultadoServidor?.data?.token || null;
      } catch (eToken) {
        console.log("Token Agora indisponível, a entrar em modo App ID:", eToken?.message);
      }

      const uidAgoraJogo = espectador ? null : uidAgoraDoUtilizador(batalha, auth.currentUser?.uid);

      await ligacao.entrar({
        appId: AGORA_APP_ID,
        canal: idBatalha,
        token: tokenReal,
        uid: uidAgoraJogo,
        publicar: !espectador,
        contentorLocal: espectador ? null : contentorLocalDoUtilizador(batalha, auth.currentUser?.uid),
        aoPublicarRemoto: (utilizador, tipoMedia) => {
          if (tipoMedia === "video") {
            const contentor = contentorDeRemoto(utilizador.uid);
            if (contentor) reproduzirVideoNoContentor(utilizador.videoTrack, contentor);
          }
          if (tipoMedia === "audio") utilizador.audioTrack?.play();
        },
        aoDespublicarRemoto: (utilizador, tipoMedia) => {
          if (tipoMedia === "video") limparContentorDeRemoto(utilizador.uid);
        },
      });
    };

    entrarNoCampo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idBatalha, batalha?.idA, espectador, ligacao.tentativa]);

    // // REPLICAÇÃO ARENA PK: ESCUTA O POTE REAL DE BOLAS EM TEMPO REAL
  useEffect(() => {
    if (!idBatalha || idBatalha === "undefined") return;

    // 1. Escuta primária e direta do Pote acumulado em Bolas dentro da partida ativa
    const unsubPotePartida = onSnapshot(doc(db, "champions_partidas", idBatalha), (docSnap) => {
      if (docSnap.exists()) {
        const dadosJogo = docSnap.data();
        if (dadosJogo.poteBolasJogo !== undefined) {
          setPoteBolas(Number(dadosJogo.poteBolasJogo || 0));
          return; // Dá prioridade absoluta ao faturamento da partida
        }
      }
    });

      // 2. Escuta secundária de segurança ligada à Árvore de eliminatórias (se o ID de jogo for válido)
    let unsubPoteArvore = null;
    if (idJogoNaArvore && idJogoNaArvore !== "undefined") {
      unsubPoteArvore = onSnapshot(doc(db, "torneios_champions_rvore", idJogoNaArvore), (docSnap) => {
        if (docSnap.exists()) {
          const dadosArvore = docSnap.data();
          // Se a partida individual não tiver o campo, lê o acumulado global do prémio em Bolas
          if (dadosArvore.poteBolasGlobalArvore !== undefined) {
            setPoteBolas(Number(dadosArvore.poteBolasGlobalArvore || 0));
          }
        }
      });
    }

    return () => {
      if (unsubPotePartida) unsubPotePartida();
      if (unsubPoteArvore) unsubPoteArvore();
    };
  }, [idBatalha, idJogoNaArvore]);

    // LÓGICA DO OLHINHO (CONTAGEM DE GENTE NO ESTÁDIO DA CHAMPIONS)
  const [totalGente, setTotalGente] = useState(0);

  useEffect(() => {
    if (!idBatalha || idBatalha === "undefined" || auth.currentUser?.uid == null) return;

    // 1. Regista que eu entrei no estádio isolado da Champions (Streamer ou Adepto)
        const meuUid = auth.currentUser?.uid;
    let minhaBancadaFutebol = 'A';

    if (meuUid && meuUid === batalha?.idA) {
      minhaBancadaFutebol = 'A';
    } else if (meuUid && meuUid === batalha?.idB) {
      minhaBancadaFutebol = 'B';
    } else {
      const charCodeSoma = meuUid ? meuUid.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) : 0;
      minhaBancadaFutebol = charCodeSoma % 2 === 0 ? 'A' : 'B';
    }

    const presencaRef = doc(db, "champions_partidas", idBatalha, "presencas", meuUid);
    setDoc(presencaRef, { 
      uid: meuUid,
      nome: auth.currentUser?.displayName || "Craque", 
      foto: auth.currentUser?.photoURL || "/hero.png",
      bancada: minhaBancadaFutebol,
      entrada: serverTimestamp() 
    });

    // 2. Ouve a lista de presenças específica deste jogo do torneio e atualiza o número total
            const q = collection(db, "champions_partidas", idBatalha, "presencas");
        const unsub = onSnapshot(q, (snap) => {
          setTotalGente(snap.size);
                    setListaEspectadoresPK(snap.docs.map(d => ({ id: d.id, ...d.data() })));
          setListaEspectadores(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });

    // 3. Quando a pessoa sai (fecha a página ou clica em sair), remove a presença
    return () => { 
      deleteDoc(presencaRef); 
      unsub();
    };
  }, [idBatalha]);

  useEffect(() => {
    const unsub = ligacao.registarListener(onSnapshot(doc(db, "champions_partidas", idBatalha), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setBatalha(data);

                // DISPARA O JOGO DA CHAMPIONS NA COLECÇÃO CORRETA COM CONTADORES DE DESEMPATE LIMPOS
        const faseAtualDoJogo = data.fase || "ESPERA";
        if (faseAtualDoJogo === "ESPERA" && data.prontoA && data.prontoB && auth.currentUser.uid === data.idA) {
          
          // Correção Cirúrgica Mestre: Inicia a 1ª Parte (300s) e zera as 3 trancas de desempate anti-fraude!
          updateDoc(doc(db, "champions_partidas", idBatalha), { 
            fase: "1ª PARTE", 
            tempo: 300,
            pontosA: 0,
            pontosB: 0,
            totalPresentesRecebidosA: 0,
            totalPresentesRecebidosB: 0,
            totalTapTapsA: 0,
            totalTapTapsB: 0,
            totalTapTaps: 0
          });

          // AVISAR A CLAQUE QUE A ELIMINATÓRIA DA CHAMPIONS COMEÇOU
          const avisarChampions = async () => {
            const idDaMinhaSalaChampions = data.salaTorneioId || "estadio_global_ativo";
            const snap = await getDocs(collection(db, "utilizadores", auth.currentUser.uid, "seguidores"));
            snap.forEach((seguidor) => {
              enviarNotificacao(
                seguidor.id, 
                auth.currentUser.uid, 
                auth.currentUser.displayName || "Craque", 
                "champions_pk", 
                { batalhaId: idBatalha, torneioId: idDaMinhaSalaChampions }
              );
            });
          };
          avisarChampions();
        }
      }
    }));
    return () => unsub();
  }, [idBatalha]);

    // 🚨 1. ANTENA DO CHAT CORRIGIDA: Puxa o feed real (chatsArena) e alimenta a fila invisível de vídeos!
  useEffect(() => {
    if (!idBatalha) return;

    // Escuta nativamente a subcoleção correta que a tua PWA exibe no ecrã
    const qChat = query(collection(db, "champions_partidas", idBatalha, "chatsArena"), orderBy("criadoEm", "asc"));
    
    const unsubChat = onSnapshot(qChat, (snap) => {
      const listaMensagens = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setMensagensChat(listaMensagens);
      if (typeof scrollToBottom === 'function') scrollToBottom();

      // DETETOR ATÓMICO: Se entrou uma nova mensagem e ela traz um gatilho de vídeo, joga-o para a fila de espera!
      snap.docChanges().forEach((change) => {
        if (change.type === "added") {
          const dadosMsg = change.doc.data();
          if (dadosMsg.videoGatilho) {
            filaPresentes.enfileirar(dadosMsg.videoGatilho);
          }
        }
      });
    });

    return () => unsubChat();
  }, [idBatalha]);

  // (O motor da fila de presentes vive em src/filaDePresentes.js.)

  // 🚨 3. RADAR DE ESPETADORES AMORTIDO: Adeptos só saem da live quando AMBOS os streamers abandonarem o estádio!
  useEffect(() => {
    if (!batalha) return;
    const meuUid = auth.currentUser?.uid;
    const souJogador = batalha?.idA === meuUid || batalha?.idB === meuUid;

    // Só ejeta se for espetador, o relógio parou e AMBOS os streamers já fecharam as câmaras (status === "encerrado")
    if (espectador && !souJogador && batalha?.fase === "FIM" && (batalha?.status === "encerrado" || batalha?.estadoEncerrado === true)) {
      const timerEjeccao = setTimeout(() => {
        if (typeof aoSair === 'function') aoSair();
      }, 3000);
      return () => clearTimeout(timerEjeccao);
    }
  }, [batalha?.fase, batalha?.status, batalha?.estadoEncerrado, espectador, aoSair]);

    // JUIZ MESTRE ULTRA-PREMIUM (CRONOGRAMA OFICIAL E 3 TRANCAS DE DESEMPATE)
    useEffect(() => {
    if (!batalha) return;
    const meuUid = auth.currentUser?.uid;
    // Tranca de Co-Árbitro: O Jogador B assume o apito se o relógio do A parar por 10s!
        // TRANCA DE CO-ÁRBITRO CHAMPIONS: O Jogador A apita. O B só assume se o relógio do A parar!
    const souOArbitro = meuUid === batalha.idA || (meuUid === batalha.idB && relogioParado);
    if (!souOArbitro) return;

    let t;
    if (batalha.fase !== "ESPERA" && batalha.fase !== "FIM") {
      t = setInterval(async () => {
        if (batalha.tempo <= 1) {
          let novaFase = "";
          let novoTempo = 0;

          // 1. FLUXO REGULAMENTAR DE TEMPO
          if (batalha.fase === "1ª PARTE") { 
            novaFase = "INTERVALO"; 
            novoTempo = 60; 
          }
          else if (batalha.fase === "INTERVALO") { 
            novaFase = "2ª PARTE"; 
            novoTempo = 300; 
          }
          else if (batalha.fase === "2ª PARTE") {
            // VERIFICAÇÃO DE EMPATE NO TEMPO REGULAMENTAR
            if (batalha.pontosA === batalha.pontosB) {
              novaFase = "PAUSA_PROLONGAMENTO";
              novoTempo = 60; // 1 Minuto de pausa regulamentar
            } else {
              novaFase = "FIM";
              novoTempo = 0;
            }
          }
          // 2. FLUXO DO PROLONGAMENTO DE ALTA TENSÃO
          else if (batalha.fase === "PAUSA_PROLONGAMENTO") {
            novaFase = "PROLONGAMENTO_1";
            novoTempo = 90; // 1 min e 30s da 1ª parte do Prol.
          }
          else if (batalha.fase === "PROLONGAMENTO_1") {
            novaFase = "INTERVALO_PROLONGAMENTO";
            novoTempo = 30; // 30 segundos de intervalo rápido
          }
          else if (batalha.fase === "INTERVALO_PROLONGAMENTO") {
            novaFase = "PROLONGAMENTO_2";
            novoTempo = 90; // 1 min e 30s da 2ª parte do Prol.
          }
          else if (batalha.fase === "PROLONGAMENTO_2") {
            // VERIFICAÇÃO DE EMPATE NO FIM DO PROLONGAMENTO
            if (batalha.pontosA === batalha.pontosB) {
              novaFase = "PAUSA_PENALTIS";
              novoTempo = 30; // 30 segundos de transição psicológica
            } else {
              novaFase = "FIM";
              novoTempo = 0;
            }
          }
          // 3. FASE DOS PÊNALTIS DE 1 MINUTO
          else if (batalha.fase === "PAUSA_PENALTIS") {
            novaFase = "PENALTIS";
            novoTempo = 60; // 1 Minuto de metralhadora de presentes normais
          }
          else if (batalha.fase === "PENALTIS") {
            novaFase = "FIM";
            novoTempo = 0;
          }

              // 4. SE O JOGO CHEGOU AO FIM, APLICA O VEREDITO REGULAMENTAR E AS TRANCAS ANTI-FRAUDE
          if (novaFase === "FIM") {
            let vencedorFinal = null;

            if (batalha.pontosA > batalha.pontosB) {
              vencedorFinal = batalha.idA;
            } else if (batalha.pontosB > batalha.pontosA) {
              vencedorFinal = batalha.idB;
            } else {
              // EXECUÇÃO EM DIRETO DAS 3 TRANCAS EM CASO DE EMPATE EXTREMO NOS PÊNALTIS
              console.log("Empate absoluto detetado nos Pênaltis! Ativando Trancas de Desempate...");
              
              // TRANCA A: Menor número de presentes recebidos (Contado pelo motor de envios)
              const totalPrsA = batalha.totalPresentesRecebidosA || 0;
              const totalPrsB = batalha.totalPresentesRecebidosB || 0;

              if (totalPrsA < totalPrsB) { vencedorFinal = batalha.idA; }
              else if (totalPrsB < totalPrsA) { vencedorFinal = batalha.idB; }
              else {
                // TRANCA B: Maior número de membros na Claque de Torneios
                const claqueASnap = await getDocs(collection(db, "utilizadores", batalha.idA, "claque_champions_membros"));
                const claqueBSnap = await getDocs(collection(db, "utilizadores", batalha.idB, "claque_champions_membros"));
                
                if (claqueASnap.size > claqueBSnap.size) { vencedorFinal = batalha.idA; }
                else if (claqueBSnap.size > claqueBSnap.size) { vencedorFinal = batalha.idB; }
                else {
                  // TRANCA C: Maior engajamento no botão de Tap Taps (🔥) acumulados no jogo
                  const tapsA = batalha.totalTapTapsA || 0;
                  const tapsB = batalha.totalTapTapsB || 0;
                  
                  if (tapsA > tapsB) { 
                    vencedorFinal = batalha.idA; 
                  } else if (tapsB > tapsA) { 
                    vencedorFinal = batalha.idB; 
                  } else {
                    // 🚨 MOEDA AO AR (ANTI-BLOQUEIO)
                    console.log("Empate absoluto em tudo! Lançando moeda ao ar...");
                    const moedaAoAr = Math.random() < 0.5;
                    vencedorFinal = moedaAoAr ? batalha.idA : batalha.idB;
                  }
                }
              }
            }

            // A. CORREÇÃO DA ÁRVORE: Atualiza a árvore do torneio dinâmico infinito na sua coleção oficial!
            if (idJogoNaArvore && idJogoNaArvore !== "undefined") {
              await updateDoc(doc(db, "torneios_champions_arvore", idJogoNaArvore), {
                vencedor: vencedorFinal,
                status: 'encerrado',
                encerradoEm: serverTimestamp()
              }).catch(e => console.log("Erro ao fechar nó da árvore:", e));
            }

            // B. PAGAMENTO DA GRANDE FINAL: Paga o Pote Acumulado em BOLAS por inteiro diretamente ao vencedor!
            if (idJogoNaArvore === 'final' || idJogoNaArvore === 'grande_final') {
              const snapPartidaFinal = await getDocs(query(collection(db, "champions_partidas"), orderBy("ultimoTiqueEm", "desc")));
              const dadosPartidaFinal = snapPartidaFinal.docs.find(d => d.id === idBatalha)?.data();
              // Lógica de resguardo para apanhar as Bolas do Pote acumuladas
              const bolasAPagar = dadosPartidaFinal?.poteBolasGlobal || 0;

              if (bolasAPagar > 0) {
                await updateDoc(doc(db, "utilizadores", vencedorFinal), {
                  saldoBolas: increment(bolasAPagar)
                });
              }
              
              // Limpa o pote global da árvore de eliminatórias de forma correta
              if (idJogoNaArvore) {
                await updateDoc(doc(db, "torneios_champions_arvore", idJogoNaArvore), {
                  poteBolasGlobalArvore: 0
                }).catch(() => {});
              }
            }
          }

          // A. Atualiza a mudança de fase (ex: 1ª Parte -> Intervalo) na coleção correta da Champions
          await updateDoc(doc(db, "champions_partidas", idBatalha), { 
            fase: novaFase, 
            tempo: novoTempo,
            ultimoTiqueEm: serverTimestamp()
          });
        } else {
          // B. SUBTRAÇÃO ATÓMICA DIRETA: Desconta exatamente 1 segundo a cada segundo
          await updateDoc(doc(db, "champions_partidas", idBatalha), {
            tempo: increment(-1),
            ultimoTiqueEm: serverTimestamp()
          }).catch(e => console.log("Erro ao descontar tempo na Champions:", e));
        }
      }, 1000);
    }
    return () => clearInterval(t);
  }, [batalha?.fase, batalha?.tempo, idBatalha, idJogoNaArvore]);

    // SENSOR VISUAL: Projeta os Alertas do Árbitro na Tela em Tempo Real (CORRIGIDO!)
  useEffect(() => {
    if (!batalha?.fase) return;

    if (batalha.fase === "1ª PARTE") {
      setMensagemJuiz("1ª PARTE - APITO INICIAL! ⚽");
    } else if (batalha.fase === "INTERVALO") {
      setMensagemJuiz("INTERVALO! REGRESSO EM BREVE... ⏳");
    } else if (batalha.fase === "2ª PARTE") {
      setMensagemJuiz("2ª PARTE - INICIADA! TUDO OU NADA! 🔥");
    } else if (batalha.fase === "PAUSA_PROLONGAMENTO") {
      setMensagemJuiz("FIM DO TEMPO REGULAMENTAR! PREPARAÇÃO PARA O PROLONGAMENTO... ⏱️");
    } else if (batalha.fase === "PROLONGAMENTO_1") {
      setMensagemJuiz("1ª PARTE DO PROLONGAMENTO - APITO INICIAL! 🚀");
    } else if (batalha.fase === "INTERVALO_PROLONGAMENTO") {
      setMensagemJuiz("INTERVALO DO PROLONGAMENTO! TROCA DE CAMPO... 🔄");
    } else if (batalha.fase === "PROLONGAMENTO_2") {
      setMensagemJuiz("2ª PARTE DO PROLONGAMENTO - RETA FINAL! 💥");
    } else if (batalha.fase === "PAUSA_PENALTIS") {
      setMensagemJuiz("PROLONGAMENTO EMPATADO! PREPARAÇÃO PARA PÊNALTIS... 🎯");
    } else if (batalha.fase === "PENALTIS") {
      setMensagemJuiz("🎯 PÊNALTIS EM DIRETO! METRALHA OS PRESENTES! 🎯");
    } else if (batalha.fase === "FIM") {
      const pontosAtuaisA = batalha.pontosA || 0;
      const pontosAtuaisB = batalha.pontosB || 0;

      // Se o jogo acabou e ninguém pontuou (tudo a zeros nas claques e pontos)
      if (pontosAtuaisA === 0 && pontosAtuaisB === 0) {
        setMensagemJuiz("EMPATE ABSOLUTO! LANÇANDO MOEDA AO AR... 🪙");
        
        const timeoutSorteio = setTimeout(() => {
          // Vai buscar o nome do vencedor legítimo escolhido pela moeda do servidor
          const nomeCampeao = batalha.vencedor === batalha.idA 
            ? (batalha.nomeA || "Jogador Esquerda") 
            : (batalha.nomeB || "Jogador Direita");
            
          setMensagemJuiz(`🎯 MOEDA AO AR: VITÓRIA DE ${nomeCampeao.toUpperCase()}! 🏆`);
          
          const timeoutFimDefinitivo = setTimeout(() => {
            setMensagemJuiz(""); 
            setMostrarResultadoFinal(true);
            
            const timeoutRes = setTimeout(() => {
              setMostrarResultadoFinal(false);
              setMostrarOpcoesFim(true);
            }, 4000);
            return () => clearTimeout(timeoutRes);
          }, 4000); 
          return () => clearTimeout(timeoutFimDefinitivo);
        }, 3000); 
        
        return () => clearTimeout(timeoutSorteio);
      } else {
        // Fluxo regulamentar normal caso o jogo tenha tido golos / pontos reais
        setMensagemJuiz("JOGO TERMINADO! REGISTANDO O VENCEDOR... 🏆");
        const timeoutFimNormal = setTimeout(() => {
          setMensagemJuiz(""); 
          setMostrarResultadoFinal(true);
          const timeoutResNormal = setTimeout(() => {
            setMostrarResultadoFinal(false);
            setMostrarOpcoesFim(true);
          }, 4000);
          return () => clearTimeout(timeoutResNormal);
        }, 3000);
        return () => clearTimeout(timeoutFimNormal);
      }
    }
    
    // Auto-limpeza do letreiro para as fases intermédias (piscam por 4 segundos)
    if (batalha.fase !== "FIM") {
      const timeout = setTimeout(() => setMensagemJuiz(""), 4000);
      return () => clearTimeout(timeout);
    }
    }, [batalha?.fase]); // 🛡️ TRANCA DE ÁRBITRO: Ignora pontos/presentes e só acorda se a Fase mudar!

    // LER MENSAGENS DA BATALHA EM TEMPO REAL ISOLADO DA CHAMPIONS
  useEffect(() => {
    if (!idBatalha) return;
    const q = query(collection(db, "champions_chats", idBatalha, "chat"), orderBy("criadoEm", "asc"));
    
    const unsub = onSnapshot(q, (snap) => {
      setMensagensChat(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setTimeout(() => scrollToBottom(), 100);
    });
    return () => unsub();
  }, [idBatalha]);

  // Hook dedicado exclusivamente a empurrar o chat para baixo a cada mensagem nova
  useEffect(() => {
    scrollToBottom();
  }, [mensagensChat?.length]);

  const enviarMensagemBatalha = async () => {
  if (textoMensagem.trim() === "") return;
  if (!idBatalha) return;
  const msgParaEnviar = textoMensagem;
  setTextoMensagem("");

  try {
    // 🔥 INJEÇÃO DE DADOS DE NÍVEL DEFINITIVA - TORNEIOS PK
    await addDoc(collection(db, "champions_chats", idBatalha, "chat"), {
      texto: `${msgParaEnviar}`,
      nome: auth.currentUser?.displayName || "Adepto",
      foto: auth.currentUser?.photoURL || "/hero.png",
      criadoEm: serverTimestamp(),
      uid: auth.currentUser?.uid,
      // Se userDados existir, calcula o nível em tempo real. Caso contrário, envia 1 por defeito para produção.
      nivelAdepto: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' && userDados ? calcularNivel(userDados.xpAdepto || 0) : 1,
      nivelJogador: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' && userDados ? calcularNivel(userDados.xpJogador || 0) : 1
    });
  } catch (errChat) {
    console.error("Erro ao enviar mensagem na Champions:", errChat);
  }
};

      const processarTapTapArena = async (e) => {
    if (e) e.stopPropagation();
    
    const cliquesNovos = (window.acumuladorTapsArena || 0) + 1;
    window.acumuladorTapsArena = cliquesNovos;

    if (window.acumuladorTapsArena >= 10) {
      window.acumuladorTapsArena = 0;
      try {
        if (idBatalha) {
          await updateDoc(doc(db, "champions_partidas", idBatalha), {
            totalTapTaps: increment(10)
          });
        }
      } catch (erroTap) {
        console.error("Erro ao computar rajada de Tap Tap na Champions:", erroTap);
      }
    }
  };

  const reiniciarBatalha = async () => {
    try {
      // Estado limpo antes da revanche, mantendo as câmaras do Agora de pé.
      reporEstadoDaPartida(false);
      
      // 🚨 REPLICAÇÃO CHAMPIONS PRIVILEGIADA: Valida o ID usando o nó estável da batalha
      if (batalha?.idA && auth.currentUser?.uid === batalha.idA) {
        await updateDoc(doc(db, "champions_partidas", idBatalha), {
          pontosA: 0,
          pontosB: 0,
          prontoA: false,
          prontoB: false,
          fase: "ESPERA",
          tempo: 0,
          ultimoVideo: null
        });
      }

    } catch (err) {
      console.error("Erro ao reiniciar pontos na Champions:", err);
    }
  };

  const avisoAtualizacaoEstadio = mostrarAvisoEstadio
    ? <PopupAtualizacaoEstadio aoFechar={() => setMostrarAvisoEstadio(false)} />
    : null;

  if (!batalha) return (
    <>
      {avisoAtualizacaoEstadio}
      <div style={{color:'white', textAlign:'center', marginTop:'50px'}}>Entrando no Estádio...</div>
    </>
  );

  const souOJogadorA = auth.currentUser.uid === batalha.idA;
  // MAPA DE JOGADORES: esquerda = anfitrião (idA), direita = adversário (idB),
  // igual para jogadores e espetadores. Nome, pontos e janela de vídeo saem
  // todos daqui — antes o vídeo vinha do uid do Agora e o nome da perspetiva de
  // quem olhava, e para um espetador as duas regras discordavam.
  const mapaJogadores = construirMapaJogadores(batalha);
  const jogadorEsq = mapaJogadores.anfitriao;
  const jogadorDir = mapaJogadores.adversario;

  const ptsEsq = jogadorEsq.pontos;
  const ptsDir = jogadorDir.pontos;
  const total = ptsEsq + ptsDir;
  const percEsq = total === 0 ? 50 : (ptsEsq / total) * 100;
  const tempoVisual = Math.max(0, Number(batalha.tempo) || 0); // nunca "-1:-1"
  const souEspetador = auth.currentUser && auth.currentUser.uid !== batalha.idA && auth.currentUser.uid !== batalha.idB;

    // LÓGICA DE VITÓRIA / DERROTA
  let resultadoEsq = "";
  let resultadoDir = "";

  if (batalha.fase === "FIM") {
    if (ptsEsq > ptsDir) {
      resultadoEsq = "VITÓRIA";
      resultadoDir = "DERROTA";
    } else if (ptsDir > ptsEsq) {
      resultadoEsq = "DERROTA";
      resultadoDir = "VITÓRIA";
    } else {
      resultadoEsq = "EMPATE";
      resultadoDir = "EMPATE";
    }
  }

    return (
    <div className="ecra-pk" style={{ backgroundColor: '#000', width: '100vw', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

      {avisoAtualizacaoEstadio}
      
      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '15px', alignItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: '900', fontSize: '24px' }}>{Math.floor(ptsEsq/1000)}</div>
          <div style={{ fontSize: '10px' }}>{jogadorEsq.nome}</div>
        </div>
        <div style={{ background: '#39FF14', color: 'black', padding: '5px 15px', borderRadius: '20px', fontWeight: '900' }}>
          {formatarTempo(tempoVisual)}
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: '900', fontSize: '24px' }}>{Math.floor(ptsDir/1000)}</div>
          <div style={{ fontSize: '10px' }}>{jogadorDir.nome}</div>
        </div>
      </div>

                  {/* BANNER DO POTE EM TEMPO REAL */}
      <div style={{ textAlign: 'center', margin: '5px 0 15px 0' }}>
        <div style={{ 
          display: 'inline-block', background: 'rgba(255, 215, 0, 0.1)', 
          padding: '5px 15px', borderRadius: '10px', border: '1px solid #FFD700' 
        }}>
          <span style={{ color: '#FFD700', fontSize: '11px', fontWeight: '900', textShadow: '0 0 5px #FFD700' }}>
            POTE CHAMPIONS: {Math.round(batalha?.poteBolasJogo || 0).toLocaleString()} ⚽
          </span>
        </div>
      </div>

      <div style={{ width: '94%', height: '32px', backgroundColor: '#222', margin: '0 auto', borderRadius: '8px', overflow: 'hidden', display: 'flex', position: 'relative', border: '2px solid #333' }}>
        <div style={{ width: `${percEsq}%`, backgroundColor: '#ff4444', transition: 'width 0.5s' }} />
        <div style={{ width: `${100 - percEsq}%`, backgroundColor: '#4444ff', transition: 'width 0.5s' }} />
        <div style={{ position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 15px', fontWeight: 'bold', fontSize: '13px', boxSizing: 'border-box', pointerEvents: 'none' }}>
          <span>{ptsEsq} Pts</span>
          <span>{ptsDir} Pts</span>
        </div>
      </div>

      {/* PONTO 8: ESTRUTURA SUPREMA ULTRA-COMPACTA CHAMPIONS (UNIFICADA EM AMARELO) */}
      <div style={{ display: 'flex', flexDirection: 'column', width: '94%', margin: '4px auto 0 auto', backgroundColor: 'rgba(255,255,255,0.02)', border: '1px solid #222', borderRadius: '12px', padding: '6px 10px', boxSizing: 'border-box', gap: '4px', zIndex: 100 }}>
        
        {/* LINHA SUPERIOR: CLAQUE ESQ · 👁️ CONTADOR · CLAQUE DIR */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px', width: '100%' }}>
          
          {/* Botão Claque Esquerda */}
          <button
            onClick={() => {
              const meuUidLogado = auth.currentUser?.uid;
              if (meuUidLogado === idA || meuUidLogado === idB) {
                alert("Os streamers em campo não podem comprar bilhetes de claque! ⚽");
                return;
              }
              if (euPertencoAClaqueA) {
                alert("Já pertences a esta Claque Oficial! 📣");
                return;
              }
              comprarAbonoClaqueChampionsA();
            }}
            style={{ 
              flex: 1, background: 'rgba(0,0,0,0.6)', 
              border: euPertencoAClaqueA ? '1px solid #39FF14' : '1px solid #FFD700', 
              borderRadius: '12px', padding: '4px 6px', 
              color: euPertencoAClaqueA ? '#39FF14' : '#FFD700', 
              fontSize: '10px', fontWeight: '900', cursor: 'pointer', whiteSpace: 'nowrap',
              boxShadow: euPertencoAClaqueA ? '0 0 6px rgba(57, 255, 20, 0.25)' : 'none'
            }}
          >
            {euPertencoAClaqueA ? "📣 CLAQUE MEMBRO (200 ⚽)" : "📣 CLAQUE (200 ⚽)"}
          </button>

          {/* 👁️ CORREÇÃO DO OLHINHO: Gatilho direto que abre a cortina sem travar em validações de tipo! */}
          <div 
            onClick={() => {
              setMostrarEspectadoresPK(true);
              setMostrarListaEspectadores(true);
            }}  
            style={{ display: 'flex', alignItems: 'center', gap: '3px', background: 'rgba(255, 215, 0, 0.1)', padding: '3px 8px', borderRadius: '10px', flexShrink: 0, cursor: 'pointer' }}
            title="Ver Adeptos no Estádio"
          >
            <span style={{ fontSize: '12px' }}>👁️</span>
            <span style={{ color: '#FFD700', fontSize: '11px', fontWeight: '950', fontFamily: 'monospace' }}>{totalGente}</span>
          </div>

          {/* Botão Claque Direita */}
          <button
            onClick={() => {
              const meuUidLogado = auth.currentUser?.uid;
              if (meuUidLogado === idA || meuUidLogado === idB) {
                alert("Os streamers em campo não podem comprar bilhetes de claque! ⚽");
                return;
              }
              if (euPertencoAClaqueB) {
                alert("Já pertences a esta Claque Oficial! 📣");
                return;
              }
              comprarAbonoClaqueChampionsB();
            }}
            style={{ 
              flex: 1, background: 'rgba(0,0,0,0.6)', 
              border: euPertencoAClaqueB ? '1px solid #39FF14' : '1px solid #FFD700', 
              borderRadius: '12px', padding: '4px 6px', 
              color: euPertencoAClaqueB ? '#39FF14' : '#FFD700', 
              fontSize: '10px', fontWeight: '900', cursor: 'pointer', whiteSpace: 'nowrap',
              boxShadow: euPertencoAClaqueB ? '0 0 6px rgba(57, 255, 20, 0.25)' : 'none'
            }}
          >
            {euPertencoAClaqueB ? "📣 CLAQUE MEMBRO (200 ⚽)" : "📣 CLAQUE (200 ⚽)"}
          </button>

        </div>

        {/* LINHA INFERIOR: ATIVOS ESQ · 🔥 CONTADOR TAPS · ATIVOS DIR */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0 2px' }}>
          
          {/* Ativos Esquerda */}
          <span style={{ color: '#FFD700', fontSize: '9px', fontWeight: 'bold', flex: 1, textAlign: 'left', opacity: 0.85 }}>
            👥 {batalha?.claqueAtivosA || 0} ativos
          </span>

          {/* O Foguinho com o total de taps da Arena */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '3px', background: 'rgba(255, 69, 0, 0.1)', padding: '2px 8px', borderRadius: '10px', flexShrink: 0 }}>
            <span style={{ fontSize: '11px' }}>🔥</span>
            <span style={{ color: '#FF4500', fontSize: '10px', fontWeight: '950', fontFamily: 'monospace' }}>{totalTapTapsArena || 0}</span>
          </div>

          {/* Ativos Direita */}
          <span style={{ color: '#FFD700', fontSize: '9px', fontWeight: 'bold', flex: 1, textAlign: 'right', opacity: 0.85 }}>
            {batalha?.claqueAtivosB || 0} ativos 👥
          </span>

        </div>

      </div>

      <div style={{ display: 'flex', flexDirection: 'row', width: '94%', height: '28vh', minHeight: '28vh', margin: '10px auto 0 auto', gap: '6px', position: 'relative', flexShrink: 0 }}>

        {/* A ENTRAR / ERRO DE LIGAÇÃO */}
        <EstadoLigacaoEstadio
          estado={ligacao.estado}
          mensagemErro={ligacao.mensagemErro}
          aoTentarDeNovo={ligacao.tentarDeNovo}
          aoSair={typeof aoSair === 'function' ? aoSair : undefined}
        />

        <div id="janela-local" className="janela-video" style={{ width: '50%', height: '100%', backgroundColor: '#111', borderRadius: '12px', position: 'relative', overflow: 'hidden', backgroundImage: jogadorEsq.foto ? `url(${jogadorEsq.foto})` : 'none', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="ecra-camara" />
        </div>
        <div id="janela-rival" className="janela-video" style={{ width: '50%', height: '100%', backgroundColor: '#111', borderRadius: '12px', position: 'relative', overflow: 'hidden', backgroundImage: jogadorDir.foto ? `url(${jogadorDir.foto})` : 'none', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="ecra-camara" />
        </div>
      </div>

              {/* PONTO 6: ESTRUTURA VISUAL DO CHAT COM FLEX CORRECTO (ESTILO ARENA PK) */}
      <div id="chat-batalha" style={{ flex: 1, minHeight: 0, width: '94%', margin: '0 auto', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px', padding: '6px 4px', boxSizing: 'border-box', overscrollBehavior: 'contain' }}>

          <div style={{ marginTop: 'auto' }} />
              
                  {mensagensChat.map((msg) => {
          const idAutor = msg.uid;
          const fotoAutorChat = msg.foto || '/hero.png';
          
        // 🚨 DETETOR VIP SUPREMO (REPLICADO DA ARENA PK): Ativa a corneta e o néon dourado se o utilizador for sócio real
const esMembroClaque = idsClaqueA?.includes(msg.uid) || idsClaqueB?.includes(msg.uid) || msg.isClaque || msg.claque === true || msg.tipoAutor === 'claque';

          return (
            <div key={msg.id} style={{
              fontSize: '13px',
              // Se for claque fica Dourado Néon, senão fica Branco padrão
              color: esMembroClaque ? '#FFD700' : '#fff',
              background: 'rgba(0, 0, 0, 0.6)',
              padding: '6px 12px',
              borderRadius: '12px',
              alignSelf: 'flex-start',
              maxWidth: '90%',
              // Borda Néon Dourada de Elite para a claque, ou verde padrão para o público comum
              border: esMembroClaque ? '1.5px solid #FFD700' : '1px solid rgba(57, 255, 20, 0.15)',
              boxShadow: esMembroClaque ? '0 0 12px rgba(255, 215, 0, 0.4)' : '0 0 8px rgba(57, 255, 20, 0.05)',
              marginBottom: '4px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontWeight: esMembroClaque ? 'bold' : 'normal'
            }}>

                      {/* FOTO REDONDA ESTILO TIKTOK COM GATILHO DE PERFIL PREPARADO */}
          <img
            src={msg.uid === "sistema_champions" ? (msg.fotoUrl || msg.foto || '/hero.png') : fotoAutorChat}
            onClick={() => {
              if (idAutor && msg.uid !== "sistema_champions") {
                window.dispatchEvent(new CustomEvent('abrirPerfilUsuario', { detail: { uid: idAutor } }));
              }
            }}
            alt="Perfil"
            style={{ width: '22px', height: '22px', borderRadius: '50%', border: msg.uid === "sistema_champions" ? '1px solid #FFD700' : 'none', objectFit: 'cover' }}
            onError={(e) => { e.target.src = '/hero.png'; }}
          />

                {/* O Nome e o Texto da mensagem alinhados */}
      <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', marginLeft: '4px' }}>
        
        {/* 🌟 LINHA HORIZONTAL DOS CRACHÁS NÉON (INJETADA AQUI) */}
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
          {/* Crachá de Adepto (Rosa) + Texto do Nível */}
          {msg.nivelAdepto && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              <img 
                src={obterImagemAdepto(msg.nivelAdepto)} 
                alt={`Adepto Lv ${msg.nivelAdepto}`} 
                style={{ width: '14px', height: '14px', borderRadius: '50%', border: '1px solid #FF007F' }} 
              />
              <span style={{ color: '#FF007F', fontSize: '9px', fontWeight: '900', textShadow: '0 0 4px #FF007F' }}>
                Lv.{msg.nivelAdepto}
              </span>
            </div>
          )}

          {/* Crachá de Jogador (Verde) + Texto do Nível */}
          {msg.nivelJogador && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              <img 
                src={obterImagemJogador(msg.nivelJogador)} 
                alt={`Jogador Lv ${msg.nivelJogador}`} 
                style={{ width: '14px', height: '14px', borderRadius: '50%', border: '1px solid #39FF14' }} 
              />
              <span style={{ color: '#39FF14', fontSize: '9px', fontWeight: '900', textShadow: '0 0 4px #39FF14' }}>
                Lv.{msg.nivelJogador}
              </span>
            </div>
          )}
        </div>

        {msg.uid === "sistema_champions" ? (

              /* 🚨 ALERTA DE PRESENTE: Nome do adepto em Dourado Néon e texto limpo */
              <span style={{ fontSize: '12px', lineHeight: '1.4' }}>
                <span style={{ color: '#FFD700', fontWeight: '950', textShadow: '0 0 10px #FFD700', marginRight: '4px' }}>
                  {msg.nomeInfrator || "🎁 Alguém"}
                </span>
                <span style={{ color: '#fff', fontWeight: '500' }}>
                  {msg.texto}
                </span>
              </span>
            ) : (
              /* 💬 MENSAGEM NORMAL DOS UTILIZADORES: Absolutamente intocável e idêntica ao teu padrão original! */
              <>
                <span style={{ fontSize: '11px', color: '#39FF14', fontWeight: 'bold' }}>
                  {esMembroClaque && <span style={{ marginRight: '4px' }}>📣</span>}
                  {msg.nome || "Adepto"}
                </span>
                <span>{msg.texto}</span>
              </>
            )}
          </div>

              </div>
            );
          })}
          <div ref={messagesEndRef} />
        </div>

        {mensagemJuiz && (
          <div style={{ position: 'absolute', width: '100%', top: '40%', textAlign: 'center', color: '#39FF14', fontSize: '26px', fontWeight: '900', textShadow: '0 0 10px black', zIndex: 50 }}>
            {mensagemJuiz}
          </div>
        )}

                {/* OPÇÕES FINAIS PARA OS STREAMERS */}
        {mostrarOpcoesFim && !souEspetador && (
          <div style={{ position: 'absolute', width: '100%', top: '50%', transform: 'translateY(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', zIndex: 30 }}>
            
            {/* 🚨 MOTOR DE FECHO DA CHAMPIONS: Grava o veredito na Árvore e limpa a arena! */}
            <button
              onClick={async () => {
                const { doc: fDoc, updateDoc: fUpdateDoc, getDoc: fGetDoc } = await import('firebase/firestore');
                
                const idDaMinhaSalaChampions = batalha?.salaTorneioId || "estadio_global_ativo";
                
                // 1. COMPUTAR VENCEDOR E ENCERRAR O JOGO NA ÁRVORE EM TEMPO REAL
                if (idDaMinhaSalaChampions && idJogoNaArvore) {
                  const salaArvoreRef = fDoc(db, "champions_ativa", idDaMinhaSalaChampions);
                  const snapArvore = await fGetDoc(salaArvoreRef);
                  
                  if (snapArvore.exists()) {
                    const dadosArvore = snapArvore.data();
                    const jogoEspecifico = dadosArvore[idJogoNaArvore];
                    
                    // Só executa a escrita se o jogo ainda não tiver sido dado como encerrado na árvore
                    if (jogoEspecifico && jogoEspecifico.status !== "encerrado") {
                      // Determina o vencedor com base nos pontos reais acumulados na partida
                      const vencedorUid = (batalha?.pontosA || 0) > (batalha?.pontosB || 0) ? batalha.idA : batalha.idB;
                      
                      await fUpdateDoc(salaArvoreRef, {
                        [`${idJogoNaArvore}.status`]: "encerrado",
                        [`${idJogoNaArvore}.vencedor`]: vencedorUid,
                        [`${idJogoNaArvore}.encerradoEm`]: new Date()
                      }).catch((e) => console.log("Erro ao carimbar veredito na árvore:", e));
                    }
                  }
                }

                // 2. ISOLAMENTO CHAMPIONS: Limpa o estado de live na ficha do streamer atual
                await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), {
                  conviteChampions: null,
                  emChampions: false
                }).catch(() => {});

                // 3. DESLIGA A CÂMARA E RETROCEDE
                if (typeof aoSair === 'function') aoSair();
              }}
              style={{ 
                background: '#ff4444', color: 'white', border: 'none', 
                padding: '15px 30px', borderRadius: '15px', fontWeight: '900', 
                fontSize: '14px', boxShadow: '0 0 15px rgba(255, 68, 68, 0.4)',
                cursor: 'pointer', width: '100%', textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              SAIR DA ARENA & SALVAR 🏆
            </button>

          </div>
        )}

                {/* BOTÃO SAIR PARA ESPETADORES (X) */}
        {souEspetador && (
          <button 
            onClick={() => window.location.href = '/?app'}
            style={{ position: 'absolute', top: '10px', right: '10px', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', width: '35px', height: '35px', borderRadius: '50%', fontWeight: 'bold', fontSize: '18px', zIndex: 100, cursor: 'pointer' }}
          >
            ✕
          </button>
        )}

                {/* ETIQUETAS DE RESULTADO FINAL */}
        {mostrarResultadoFinal && (
          <>
            {ptsEsq === ptsDir ? (
              /* SE FOR EMPATE: UMA MENSAGEM NO CENTRO */
              <div style={{ position: 'absolute', left: '50%', top: '40%', transform: 'translate(-50%, -50%)', color: '#ffcc00', fontSize: '40px', fontWeight: '900', textShadow: '0 0 20px black', zIndex: 20, whiteSpace: 'nowrap' }}>
                EMPATE 🤝
              </div>
            ) : (
              /* SE HOUVER VENCEDOR: VITÓRIA E DERROTA */
              <>
                <div style={{ position: 'absolute', left: '25%', top: '40%', transform: 'translate(-50%, -50%)', color: resultadoEsq === "VITÓRIA" ? "#39FF14" : "#ff4444", fontSize: '30px', fontWeight: '900', textShadow: '0 0 15px black', zIndex: 20 }}>
                  {resultadoEsq}
                </div>
                <div style={{ position: 'absolute', left: '75%', top: '40%', transform: 'translate(-50%, -50%)', color: resultadoDir === "VITÓRIA" ? "#39FF14" : "#ff4444", fontSize: '30px', fontWeight: '900', textShadow: '0 0 15px black', zIndex: 20 }}>
                  {resultadoDir}
                </div>
              </>
            )}
          </>
        )}

        {/* MOTOR UNIFICADO DO TORNEIO: PRESENTES MP4 COM CHROMA KEY (SEM APAGÃO PRETO) */}
        {videoAtivo && (
          <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'transparent',
            pointerEvents: 'none'
          }}>
            {/* 💍 Presente com versão sem fundo (assets/presentes/transparentes).
                O som da bomba já sai do motor da fila; o vídeo vai sem som, como antes.
                Fecha-se também por erro ou tempo limite: a fila nunca fica encravada. */}
            {videoSemFundo(videoAtivo) ? (
              <PresenteTransparente
                key={chaveVideoAtivo}
                src={videoSemFundo(videoAtivo)}
                comSom={false}
                aoTerminar={() => filaPresentes.terminar(chaveVideoAtivo)}
              />
            ) : (
            <div style={{ position: 'relative', width: '300px', height: '300px' }}>
              {/* Canvas que tritura e limpa o fundo VERDE em tempo real no torneio */}
              <canvas
                ref={(canvas) => {
                  if (!canvas) return;
                  const video = document.getElementById('video_player_torneio_premium');
                  if (!video) return;
                  const ctx = canvas.getContext('2d');
                  let frameId;
                  
                  const limparVerde = () => {
                    if (video.paused || video.ended) return;
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const len = imgData.data.length;
                    
                    for (let i = 0; i < len; i += 4) {
                      const r = imgData.data[i];
                      const g = imgData.data[i+1];
                      const b = imgData.data[i+2];
                      
                      // Fórmula Chroma Key para o verde do Kling AI
                      if (g > 55 && g > r * 1.15 && g > b * 1.15) {
                        imgData.data[i+3] = 0;
                      }
                    }
                    ctx.putImageData(imgData, 0, 0);
                    frameId = requestAnimationFrame(limparVerde);
                  };
                  
                  video.addEventListener('play', limparVerde);
                  return () => cancelAnimationFrame(frameId);
                }}
                width={480}
                height={480}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
                          {/* O vídeo corre em background e desliga o Canvas de forma atómica no exato segundo em que terminar! */}
              <video
                id="video_player_torneio_premium"
                src={videoAtivo}
                autoPlay
                playsInline
                muted
                onEnded={() => filaPresentes.terminar(chaveVideoAtivo)}
                // Um vídeo que falha nunca dispara o "ended": sem isto a fila
                // ficava parada para sempre e mais nenhum presente aparecia.
                onError={() => filaPresentes.terminar(chaveVideoAtivo)}
                style={{ display: 'none' }}
              />
            </div>
            )}
          </div>
        )}

      {/* PONTO 7: BARRA DE ENTRADA DO CHAT E CONTROLOS (ESTILO REPLICADO DA ARENA PK) */}
<div style={{ position: 'relative', marginTop: 'auto', width: '100%', display: 'flex', flexDirection: 'column', paddingBottom: 'calc(25px + env(safe-area-inset-bottom))', paddingLeft: '15px', paddingRight: '15px', paddingTop: '10px', background: 'rgba(0,0,0,0.9)', borderTop: '1px solid #222', zIndex: 1000, boxSizing: 'border-box', flexShrink: 0 }}>
  
  {/* BARRA DE FERRAMENTAS HORIZONTAL - SÓ PARA OS STREAMERS NA FASE DE ESPERA OU REGULAMENTAR */}
  {!souEspetador && (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', width: '100%' }}>

                                    {/* LINHA SUPERIOR DOS 4 BOTÕES DO COMBATE - REAJUSTADA COM ESPAÇAMENTO */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              gap: '15px', 
              width: '100%', 
              boxSizing: 'border-box',
              marginBottom: '15px'
            }}>
              
              {/* 1. BOTÃO INICIAR PK (COM DESBLOQUEIO TRUE CONTRA CAMPOS INDEFINIDOS) */}
              <button
  onClick={() => {
    // Só deixa clicar para dar PRONTO se o jogo ainda estiver em ESPERA
    if (!batalha?.fase || batalha?.fase === "ESPERA") {
      const campoPronto = souOJogadorA ? "prontoA" : "prontoB";
      updateDoc(doc(db, "champions_partidas", idBatalha), { [campoPronto]: true });
    }
  }}
  style={{
    background: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? '#222' : ((souOJogadorA ? batalha?.prontoA === true : batalha?.prontoB === true) ? 'rgba(57, 255, 20, 0.2)' : '#39FF14'),
    color: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? '#666' : 'black',
    border: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? '1px solid #444' : 'none',
    borderRadius: '25px', padding: '0 25px', height: '42px',
    fontWeight: '950', fontSize: '13px', cursor: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? 'default' : 'pointer', 
    letterSpacing: '0.5px', boxShadow: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? 'none' : '0 0 10px #39FF14',
    whiteSpace: 'nowrap', textTransform: 'uppercase'
  }}
>
  { (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") 
    ? "EM JOGO ⚔️" 
    : ((souOJogadorA ? batalha?.prontoA : batalha?.prontoB) ? "AGUARDANDO..." : "INICIAR PK") 
  }
</button>

              {/* 2. BOTÃO CANCELAR REDONDO (✕) */}
              <button 
                onClick={async () => {
                  if (window.confirm("Queres mesmo cancelar o desafio e sair da Arena da Champions? ⚽🟥")) {
                    try {
                      await updateDoc(doc(db, "utilizadores", auth.currentUser.uid), { conviteChampions: null, emChampions: false }).catch(() => {});
                      if (batalha?.idB) await updateDoc(doc(db, "utilizadores", batalha.idB), { conviteChampions: null }).catch(() => {});
                      if (batalha?.idA) await updateDoc(doc(db, "utilizadores", batalha.idA), { conviteChampions: null }).catch(() => {});
                      await deleteDoc(doc(db, "champions_partidas", idBatalha)).catch(() => {});
                      if (typeof aoSair === 'function') aoSair();
                      else window.location.href = '/?app';
                    } catch (e) { console.error(e); }
                  }
                }}
                style={{ background: 'rgba(255, 49, 49, 0.15)', color: '#FF3131', border: '1px solid #FF3131', borderRadius: '50%', width: '42px', height: '42px', fontSize: '18px', fontWeight: '900', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 10px rgba(255, 49, 49, 0.3)' }}
                title="Sair / Cancelar Desafio"
              >
                ✕
              </button>

                            {/* 3. BOTÃO PARTILHA PREMIUM (🔗) - ABRE AS REDES SOCIAIS NATIVAS PARA O STREAMER */}
              <button
                onClick={async () => {
                  const urlTorneio = window.location.href;
                  if (navigator.share) {
                    try {
                      await navigator.share({
                        title: 'Vem assistir à Champions PK! ⚽🔥',
                        text: 'Entra no estádio agora para apoiar o teu craque favorito em direto!',
                        url: urlTorneio,
                      });
                    } catch (errShare) {
                      console.log("Partilha fechada:", errShare);
                    }
                  } else {
                    try {
                      await navigator.clipboard.writeText(urlTorneio);
                      alert("Link do estádio copiado para a área de transferência! 📋⚽");
                    } catch (errClip) {
                      console.error("Erro ao copiar:", errClip);
                    }
                  }
                }}
                style={{ background: '#111', color: '#39FF14', border: '1px solid #39FF14', borderRadius: '50%', width: '42px', height: '42px', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 10px rgba(57, 255, 20, 0.3)' }}
                title="Partilhar Estádio"
              >
                🔗
              </button>

                          {/* 4. BOTÃO MICROFONE DINÂMICO PREMIUM (🎙️ / 🔇) - ESTILO REPLICADO DA ARENA PK */}
                        <button
              onClick={alternarMicrofoneBatalha}
              style={{
                background: microLigado ? '#39FF14' : '#222',
                color: microLigado ? 'black' : 'white',
                border: microLigado ? 'none' : '1px solid #ff4444',
                borderRadius: '50%',
                width: '42px',
                height: '42px',
                fontSize: '18px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: microLigado ? '0 0 10px #39FF14' : 'none'
              }}
              title={microLigado ? "Mutar Microfone" : "Ligar Microfone"}
            >
              {microLigado ? "🎙️" : "🔇"}
            </button>

            </div>

            {/* LINE INFERIOR: BOTÃO SUPREMO DE FECHAR A ARENA COMPACTO */}
            <button
              onClick={async () => {
                if (window.confirm("Queres encerrar o estádio e abandonar a partida da Champions? 🟥")) {
                  try {
                    await updateDoc(doc(db, "utilizadores", auth.currentUser.uid), { conviteChampions: null, emChampions: false }).catch(() => {});
                    if (auth.currentUser.uid === batalha?.idA || auth.currentUser.uid === batalha?.idB) {
                      await updateDoc(doc(db, "champions_partidas", idBatalha), { fase: "FIM", tempo: 0, abandonadaPor: auth.currentUser.uid }).catch(() => {});
                      for (const uidLutador of [batalha?.idA, batalha?.idB]) {
                        if (uidLutador) await updateDoc(doc(db, "utilizadores", uidLutador), { conviteChampions: null }).catch(() => {});
                      }
                    }
                    await ligacao.terminar();
                    if (typeof aoSair === 'function') aoSair();
                    else window.location.href = '/?app';
                  } catch (eSupreme) { console.error(eSupreme); }
                }
              }}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#000', color: '#FF3131', border: '2px solid #FF3131', borderRadius: '30px', padding: '12px 24px', fontWeight: '900', fontSize: '14px', cursor: 'pointer', boxShadow: '0 0 15px rgba(255, 49, 49, 0.4)', width: '90%', textTransform: 'uppercase', letterSpacing: '0.5px' }}
            >
              <span style={{ fontSize: '16px', marginRight: '8px' }}>🟥</span>
              FECHAR ARENA
            </button>

          </div>
        )}

                {/* INTERFACE INFERIOR CHAMPIONS: BARRA FLUIDA UNIFICADA DO ADEPTO */}
        {!souEspetador ? (
          /* A. SE FOR STREAMER: Oculta a caixa de texto para dar foco total às ferramentas de jogo */
          <div style={{ height: '0px' }} />
        ) : (
                    /* B. SE FOR ESPETADOR: Abre o input de texto redondo em fluxo flexível (Estilo Arena PK - CORRIGIDO SEM CORTES!) */
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', width: '100%', boxSizing: 'border-box' }}>
            <input 
              value={textoMensagem} 
              onChange={(e) => setTextoMensagem(e.target.value)} 
              onKeyDown={(e) => e.key === 'Enter' && enviarMensagemBatalha()} 
              placeholder="Diz algo..." 
              style={{ 
                flex: 1, 
                minWidth: 0, /* Força o input a encolher para dar espaço aos botões no telemóvel */
                padding: '10px 14px', 
                borderRadius: '25px', 
                border: '1px solid #333', 
                background: '#111', 
                color: 'white', 
                fontSize: '13px' 
              }} 
            />
            
            {/* O Botão da Bola de Futebol para Enviar a Mensagem */}
            <button 
              onClick={enviarMensagemBatalha} 
              style={{ 
                background: '#39FF14', 
                border: 'none', 
                width: '36px', 
                height: '36px', 
                borderRadius: '50%', 
                fontSize: '18px', 
                cursor: 'pointer', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              ⚽
            </button>

            {/* O BOTÃO DO FOGO (TAP TAP) ALINHADO NA LINHA FLUIDA */}
            <button
              onClick={processarTapTapArena}
              style={{
                background: 'rgba(255, 0, 127, 0.1)',
                border: '1px solid #FF007F',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                fontSize: '18px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 0 8px rgba(255, 0, 127, 0.3)',
                flexShrink: 0
              }}
            >
              🔥
            </button>

            {/* 🚨 REPLICAÇÃO ARENA PK: O BOTÃO REDONDO DE PRESENTES 🎁 INTEGRADO NA BARRA PRINCIPAL */}
                        {batalha?.fase && ["1ª PARTE", "2ª PARTE", "PROLONGAMENTO_1", "PROLONGAMENTO_2", "PENALTIS", "PENALTIES"].includes(String(batalha.fase).toUpperCase()) && (
              <button 
                onClick={() => setMostrarPresentesPK(true)}
                style={{ 
                  background: 'linear-gradient(135deg, #FF8C00 0%, #FF4500 100%)', 
                  border: 'none', 
                  width: '36px', 
                  height: '36px', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  cursor: 'pointer', 
                  boxShadow: '0 0 8px rgba(255, 69, 0, 0.4)', 
                  fontSize: '18px', 
                  flexShrink: 0 
                }}
                title="Enviar Presente"
              >
                🎁
              </button>
            )}
          </div>
        )}

        {/* BOTÃO DE PARTILHA PREMIUM (🔗) - FLUTUANTE DISCRETO SÓ PARA O PÚBLICO */}
        {souEspetador && (
          <div style={{ position: 'absolute', bottom: '85px', right: '15px', zIndex: 1005 }}>
            <button
              onClick={async () => {
                const urlTorneio = window.location.href;
                if (navigator.share) {
                  try {
                    await navigator.share({
                      title: 'Vem assistir à Champions PK! ⚽🔥',
                      text: 'Entra no estádio agora para apoiar o teu craque favorito em direto!',
                      url: urlTorneio,
                    });
                  } catch (errShare) {
                    console.log("Partilha fechada:", errShare);
                  }
                } else {
                  try {
                    await navigator.clipboard.writeText(urlTorneio);
                    alert("Link do estádio copiado para a área de transferência! 📋⚽");
                  } catch (errClip) {
                    console.error("Erro ao copiar:", errClip);
                  }
                }
              }}
              style={{ background: '#111', color: '#39FF14', border: '1px solid #39FF14', borderRadius: '50%', width: '38px', height: '38px', fontSize: '16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 8px rgba(57, 255, 20, 0.2)' }}
              title="Partilhar Estádio"
            >
              🔗
            </button>
          </div>
        )}

      </div> {/* 🛑 FECHO MESTRE DO PONTO 7: Tranca a barra inferior por completo! */}

      {/* PONTO 7D: GAVETA SUPREMA DE PRESENTES CHAMPIONS (ESTILO REPLICADO DA ARENA PK - PURIFICADO!) */}
      {mostrarPresentesPK && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, backgroundColor: '#111', borderTop: '2px solid #39FF14', borderTopLeftRadius: '25px', borderTopRightRadius: '25px', padding: '15px 20px 25px 20px', zIndex: 3000, boxShadow: '0 -10px 30px rgba(0,0,0,0.9)', boxSizing: 'border-box', animation: 'slideUp 0.25s ease-out' }}>
          
          {/* Cabeçalho da Gaveta */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <span style={{ color: '#39FF14', fontSize: '14px', fontWeight: '950', letterSpacing: '0.5px', textTransform: 'uppercase' }}>ESCOLHE O PRESENTE ⚽</span>
            <button 
              onClick={() => setMostrarPresentesPK(false)}
              style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}
            >
              Fechar ✕
            </button>
          </div>

          {/* DOIS BOTÕES GIGANTES NO TOPO: SELEÇÃO DE STREAMER (CORRIGIDO SEM NOMES ESTÁTICOS) */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '15px', width: '100%' }}>
            
            {/* Streamer Esquerda (Vermelho) */}
            <button
              onClick={() => setStreamerSelecionadoPresente('A')}
              style={{
                flex: 1, height: '44px', borderRadius: '12px', fontSize: '13px', fontWeight: '900', cursor: 'pointer',
                background: '#1a1a1a', color: '#ff4444',
                border: streamerSelecionadoPresente === 'A' ? '2px solid #ff4444' : '1px solid #333',
                boxShadow: streamerSelecionadoPresente === 'A' ? '0 0 10px rgba(255, 68, 68, 0.2)' : 'none',
                textTransform: 'uppercase', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', padding: '0 8px'
              }}
            >
              🟥 {batalha?.nomeA || "STREAMER A"}
            </button>

            {/* Streamer Direita (Azul) */}
            <button
              onClick={() => setStreamerSelecionadoPresente('B')}
              style={{
                flex: 1, height: '44px', borderRadius: '12px', fontSize: '13px', fontWeight: '900', cursor: 'pointer',
                background: '#1a1a1a', color: '#4444ff',
                border: streamerSelecionadoPresente === 'B' ? '2px solid #4444ff' : '1px solid #333',
                boxShadow: streamerSelecionadoPresente === 'B' ? '0 0 10px rgba(68, 68, 255, 0.2)' : 'none',
                textTransform: 'uppercase', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', padding: '0 8px'
              }}
            >
              🟦 {batalha?.nomeB || "STREAMER B"}
            </button>

          </div>

          {/* 🚨 REPLICAÇÃO ARENA PK: GRELHA RÍGIDA DE 3 COLUNAS FIXAS COM SCROLL VERTICAL EXCLUSIVO */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', maxHeight: '230px', overflowY: 'auto', overflowX: 'hidden', padding: '4px 2px', boxSizing: 'border-box', WebkitOverflowScrolling: 'touch' }}>
          
            {typeof LISTA_PRESENTES !== 'undefined' && LISTA_PRESENTES.map((pres) => (
              <div 
                key={pres.id}
                onClick={async () => {
  setMostrarPresentesPK(false); // ⚡ FECHO IMEDIATO: A gaveta desce no mesmo milissegundo!
  const idDestinatario = streamerSelecionadoPresente === 'A' ? batalha?.idA : batalha?.idB;
  if (idDestinatario) {
    await enviarPresente(pres, idDestinatario);
  }
}}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#1a1a1a', padding: '6px 4px', borderRadius: '10px', border: '1px solid #252525', cursor: 'pointer', boxSizing: 'border-box', width: '100%', minWidth: 0 }}
>
  <img src={pres.icone} style={{ width: '32px', height: '32px', marginBottom: '2px', objectFit: 'contain' }} alt="" />
  <span style={{ fontSize: '9px', color: '#fff', fontWeight: 'bold', textAlign: 'center', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pres.nome}</span>
  <span style={{ fontSize: '8px', color: '#FFD700', marginTop: '1px', fontWeight: 'black', display: 'flex', alignItems: 'center', gap: '2px', justifyContent: 'center' }}>⚽ {pres.preco}</span>
              </div>
            ))}
          </div>

        </div>
      )}

      {/* MODAL TRANSLÚCIDO COM A LISTA DE ESPECTADORES DA CHAMPIONS (CORRIGIDO!) */}
      {(mostrarListaEspectadores || mostrarEspectadoresPK) && (
        <div style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(8px)',
          zIndex: 999999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            background: '#0d0d0d',
            border: '2px solid #39FF14',
            boxShadow: '0 0 20px rgba(57, 255, 20, 0.3)',
            borderRadius: '16px',
            width: '100%',
            maxWidth: '360px',
            maxHeight: '70vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>
            {/* Cabeçalho do Pop-up (CORRIGIDO COM SPACE-BETWEEN) */}
            <div style={{
              padding: '16px',
              borderBottom: '1px solid #262626',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              boxSizing: 'border-box'
            }}>
              <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '16px' }}>
                👥 Claque no Estádio ({(listaEspectadoresPK || listaEspectadores || []).length})
              </span>
              <button 
                onClick={() => {
                  setMostrarListaEspectadores(false);
                  setMostrarEspectadoresPK(false);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#ff4d4d',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                ✕
              </button>
            </div>

                        {/* Lista dos Adeptos com Scrollbar Invisível (CORRIGIDO PARA A VARIÁVEL REAL) */}
            <div style={{ padding: '16px', overflowY: 'auto', flex: 1 }}>
              {(!listaEspectadoresPK || listaEspectadoresPK.length === 0) ? (
                <p style={{ color: '#8c8c8c', textAlign: 'center', fontSize: '14px', margin: '20px 0' }}>
                  Ainda não há adeptos nas bancadas...
                </p>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {listaEspectadoresPK.map((adepto) => (
                    <div 
                      key={adepto.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '12px',
                        background: '#141414',
                        padding: '10px',
                        borderRadius: '8px',
                        border: '1px solid #262626'
                      }}
                    >
                      {/* Lado Esquerdo: Foto e Nome agrupados */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <img 
                          src={adepto.foto || "/hero.png"} 
                          alt={adepto.nome} 
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '2px solid #39FF14',
                            flexShrink: 0
                          }}
                          onError={(e) => { e.target.src = "/hero.png"; }}
                        />
                        <span style={{ color: '#fff', fontSize: '14px', fontWeight: '500' }}>
                          {adepto.nome || "Fã Incógnito"}
                        </span>
                      </div>

                      {/* Lado Direito: Bloco de Ações (Seguir e Expulsar) */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {/* 1. BOTÃO SEGUIR PREMIUM */}
                        {adepto.uid !== auth.currentUser?.uid && (
                          window.seguidosLocais?.includes(adepto.uid) ? (
                            <span style={{ color: '#39FF14', fontSize: '11px', fontWeight: 'bold', padding: '6px 12px' }}>
                              ✅ SEGUIDO
                            </span>
                          ) : (
                            <button
                              onClick={async (e) => {
                                e.stopPropagation();
                                try {
                                  const { doc: fDoc, setDoc: fSetDoc, serverTimestamp: fTime } = await import('firebase/firestore');
                                  
                                  await fSetDoc(fDoc(db, "utilizadores", auth.currentUser.uid, "seguindo", adepto.uid), {
                                    nome: adepto.nome, data: fTime()
                                  });

                                  await fSetDoc(fDoc(db, "utilizadores", adepto.uid, "seguidores", auth.currentUser.uid), {
                                    nome: auth.currentUser.displayName || "Craque", data: fTime()
                                  });

                                  if (!window.seguidosLocais) window.seguidosLocais = [];
                                  window.seguidosLocais.push(adepto.uid);
                                  setTotalGente(prev => prev);
                                } catch (errSeg) { console.error(errSeg); }
                              }}
                              style={{ backgroundColor: 'rgba(255, 0, 127, 0.1)', color: '#FF007F', border: 'none', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer' }}
                            >
                              + SEGUIR
                            </button>
                          )
                        )}

                        {/* 2. BOTÃO EXPULSAR BLINDADO E NATIVO PARA A CHAMPIONS */}
                        {(() => {
                          const euSouOStreamerA = auth.currentUser?.uid === batalha?.idA;
                          const euSouOStreamerB = auth.currentUser?.uid === batalha?.idB;
                          const userEhJogador = adepto.uid === batalha?.idA || adepto.uid === batalha?.idB;
                          const souEuProprio = adepto.uid === auth.currentUser?.uid;

                          const podeExpulsar = !userEhJogador && (
                            (euSouOStreamerA && adepto.bancada === 'A') || 
                            (euSouOStreamerB && adepto.bancada === 'B')
                          );

                          if (podeExpulsar && !souEuProprio) {
                            return (
                              <button
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  if (window.confirm(`Tens a certeza que queres expulsar @${adepto.nome}? 🟥`)) {
                                    try {
                                      const { doc: fDoc, setDoc: fSetDoc, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
                                      
                                      await fSetDoc(fDoc(db, "champions_partidas", idBatalha, "expulsos", adepto.uid), {
                                        uid: adepto.uid, nome: adepto.nome, expulsoPor: auth.currentUser.uid, data: Date.now()
                                      });

                                      await fDeleteDoc(fDoc(db, "champions_partidas", idBatalha, "presencas", adepto.uid));
                                      alert(`Utilizador expulso com sucesso!`);
                                    } catch (errKick) { console.error(errKick); }
                                  }
                                }}
                                style={{ backgroundColor: '#ff4444', color: 'black', border: 'none', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', marginLeft: '6px' }}
                              >
                                EXPULSAR 🟥
                              </button>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default TorneiosPK;


